"use strict";

//Set global variables
let isSoldierNavOpen = false;
let isCountryNavOpen = false;
let menuState = 0;
let isModalOpen = false;
const modal = document.getElementById("modalAboutProject");
const sidenavDummy = document.getElementById("sidenavDummy");
const countryTags = ["CAN", "FRA", "GBR", "USA", "VEN"];
const infoBox = document.getElementById("infoBox");
const map = document.querySelector(".map");

//Soldier panel variables
let soldierData = {};
let soldierButtons = [];
let currentPdfUrl = "url";
let countryTag = "tag";
let tempDomObj;
let loadedDom = 0;
const imgPlaceholder = new Image();
const soldierNavbar = document.getElementById("soldierNav");
const countryNavbar = document.getElementById("countryNav");
const countryName = document.getElementById("countryName");
const soldierImage = document.getElementById("soldierImage");
const soldierName = document.getElementById("soldierName");
const soldierBirthDate = document.getElementById("soldierBirthDate");
const soldierDeathDate = document.getElementById("soldierDeathDate");
const soldierRank = document.getElementById("soldierRank");
const soldierFullName = document.getElementById("soldierFullName");
const soldierDescription = document.getElementById("soldierDescription");
const credits = document.querySelector(".author");

//Buttons
const btnSoldierMenu = document.querySelector("#btnSoldierMenu");
btnSoldierMenu.addEventListener("click", function () {
  openSoldierNav();
});
const btnCloseSoldierNav = document.querySelector("#btnCloseSoldierNav");
btnCloseSoldierNav.addEventListener("click", function () {
  closeSoldierNav();
});
const btnCountryMenu = document.querySelector("#btnCountryMenu");
btnCountryMenu.addEventListener("click", function () {
  openCountryNav();
});
const btnCloseNav = document.querySelector("#btnCloseNav");
btnCloseNav.addEventListener("click", function () {
  closeCountryNav();
});
const btnAboutProject = document.querySelector("#btnAboutProject");
btnAboutProject.addEventListener("click", function () {
  openModal();
});
const btnCloseModal = document.querySelector("#btnCloseModal");
btnCloseModal.addEventListener("click", function () {
  closeModal();
});
const btnGoBack = document.querySelector("#btnGoBack");
btnGoBack.addEventListener("click", function () {
  showOverlay(false);
});
const btnPdfButton = document.querySelector("#btnPdfButton");
btnPdfButton.addEventListener("click", function () {
  openPdf();
});

//Country Buttons
const btnCAN = document.querySelector("#btnCAN");
btnCAN.addEventListener("click", function () {
  showOverlay(true, "CAN");
});
const btnFRA = document.querySelector("#btnFRA");
btnFRA.addEventListener("click", function () {
  showOverlay(true, "FRA");
});
const btnGBR = document.querySelector("#btnGBR");
btnGBR.addEventListener("click", function () {
  showOverlay(true, "GBR");
});
const btnUSA = document.querySelector("#btnUSA");
btnUSA.addEventListener("click", function () {
  showOverlay(true, "USA");
});
const btnVEN = document.querySelector("#btnVEN");
btnVEN.addEventListener("click", function () {
  showOverlay(true, "VEN");
});
const CAN = document.querySelector("#CAN");
CAN.addEventListener("click", function () {
  showOverlay(true, "CAN");
});
const FRA = document.querySelector("#FRA");
FRA.addEventListener("click", function () {
  showOverlay(true, "FRA");
});
const GBR = document.querySelector("#GBR");
GBR.addEventListener("click", function () {
  showOverlay(true, "GBR");
});
const USA = document.querySelector("#USA");
USA.addEventListener("click", function () {
  showOverlay(true, "USA");
});
const VEN = document.querySelector("#VEN");
VEN.addEventListener("click", function () {
  showOverlay(true, "VEN");
});

//Soldier data
const soldierObj = [
  {
    countryTag: "CAN",
    soldiers: [
      {
        placeholder: "true",
        lastName: "B",
      },
      {
        placeholder: "true",
        lastName: "D",
      },
      {
        placeholder: "true",
        lastName: "P",
      },
      {
        placeholder: "true",
        lastName: "R",
      },
      {
        placeholder: "true",
        lastName: "Š",
      },
      {
        alive: "false",
        firstName: "Arūnas",
        lastName: "Dailydė",
        uid: "arunas_dailyde",
        birthDate: "1937 m.",
        deathDate: "Nežinoma",
        pdf: "https://www.vdkaromuziejus.lt/wp-content/uploads/2021/01/arunas_dailyde.pdf",
        rank: "Kapitonas",
        description:
          "Iš proto varantį dantų skausmą veikiausiai visi esame patyrę ir žinome, ką tai reiškia, norisi tik vieno – kuo greičiau patekti pas profesionalų stomatologą, kuris išvaduotų mus nuo kančių. Kpt. Arūnas Dailydė yra vienas tų išvaduotojų, jis – Kanados kariuomenės Karo medicinos tarnybos dantų gydytojas.<br>Arūnas Dailydė gimė 1937 m. Šiauliuose, kaip pats sako, 1939 m. jį tėvelis nufotografavo prie Lietuvos kariuomenės palapinių – tai ir buvo jo pirmasis susitikimas su kariuomene. 1944 m. Antrojo pasaulinio karo audroms siaučiant, šeima pasitraukė į Vakarus (apsistojo pabėgėlių stovykloje Vokietijoje), po to emigravo į Kanadą. Bręsdamas suprato, kad didžiausias džiaugsmas, kai gali padėti kitiems, galbūt todėl ir pasirinko stomatologo profesiją, o studijų finansinę naštą palengvino savanorio tarnyba Kanados kariuomenėje. A. Dailydė buvo paskirtas stomatologu Jungtinių Tautų ekstremaliųjų situacijų pajėgų misijoje Egipte. Per 50 metų trukusią dantų taisymo tarnybą A. Dailydė padėjo ne tik kariams, bet ir civiliams. Kpt. Arūnas Dailydė už pagalbą žmonėms ir už puikiai atliktą tarnybą buvo apdovanotas Jungtinių Tautų ekstremaliųjų situacijų pajėgų misijos medaliu bei Kanados taikos palaikymo (taikdarių) tarnybos medaliu.",
        placeholder: "false",
      },
      {
        alive: "false",
        firstName: "Juozas",
        lastName: "Pajaujis",
        uid: "juozas_pajaujis",
        birthDate: "1918 m.",
        deathDate: "2010 m.",
        pdf: "https://www.vdkaromuziejus.lt/wp-content/uploads/2021/01/juozas_pajaujis.pdf",
        rank: "Eilinis",
        description:
          "Tai istorija apie kuklų lietuvį, Juozą Pajaujį, kuris prisidėjo išlaisvinant nacistinės Vokietijos okupuotą Europą.<br>Juozas Pajaujis gimė 1918 m. lietuvių šeimoje Kanadoje, o 1920 m. sugrįžo į tėvų gimtinę Oškinius (Punsko apylinkės, dabar Lenkija). Visą laiką dirbęs tėvų ūkyje 1937 m. nusprendė išvykti į Kanadą, nes turėjo jos pilietybę, užsidirbti. Prasidėjus Antrajam pasauliniam karui, 1941 m. sausio 11 d. jis pasuko kario keliu – pradėjo tarnybą Kanados lauko kariuomenės 19-ajame pulke, patys šio pulko kariai šį dalinį mėgdavo vadinti „Pragaru ant ratų“. Po bazinių mokymų J. Pajaujis su pulku buvo išsiųstas į Angliją. Vėliau pulkas, kuriame tarnavo Juozas Pajaujis, kovojo Kane (pranc. Caene) Prancūzijoje, taip pat padėjo išlaisvinant iš nacių okupacijos Nyderlandus. Karo baisumus pavyko išgyventi, o už nuopelnus ir pasižymėjimą Antrojo pasaulinio karo metais pabūklo šaulys Juozas Pajaujis buvo apdovanotas daugybe apdovanojimų: 1939–1945 Karo žvaigžde (Jungtinė Karalystė), Prancūzijos ir Vokietijos Karo Žvaigžde (Jungtinė Karalystė), 1939–1945 karo medaliu (Jungtinė Karalystė), Gynybos medaliu (Jungtinė Karalystė) bei Kanados savanorių tarnybos medaliu.",
        placeholder: "false",
      },
      {
        alive: "false",
        firstName: "Stasys",
        lastName: "Prakapas",
        uid: "stasys_prakapas",
        birthDate: "1924 m.",
        deathDate: "Nežinoma",
        pdf: "https://www.vdkaromuziejus.lt/wp-content/uploads/2021/01/stasys_prakapas.pdf",
        rank: "Seržantas",
        description:
          "Stasio Prakapo istorija neeilinė, jam teko tarnauti net dviejose kitų šalių kariuomenėse. Jis patyrė ir šilto, ir šalto, o 21 gimtadienio proga, kaip pats sako, gavo didžiausią dovaną – gyvybę.<br>S. Prakapas gimė ir augo Lietuvoje, prasidėjus Antrajam pasauliniam karui 1942 m. Kaune prievarta buvo paimtas į Vokietijos kariuomenę, daugiau nei dvejus metus jis tarnavo Trečiojo Reicho liuftvafės (vok. Luftwaffe Vokietijos (iki 1945 m.) pajėgų priešlėktuvinės gynybos daliniuose. Kartu su šiuo padaliniu buvo išsiųstas į Rytų frontą, tuometinio Leningrado (dabar – Sankt Peterburgas) prieigas. Vėliau jis atsidūrė Latvijos teritorijoje, Kuršo karo fronte, dalyvavo Kuršo apsuptyje vykusiose intensyviose kautynėse, vėliau – Berlyno gynybos operacijose. Už dalyvavimą mūšiuose Rytų fronte S. Prakapas buvo apdovanotas sidabriniu priešlėktuvinės gynybos pasižymėjimo kautynėse ženklu. Po karo, atsidūręs Kanadoje, savo noru įstojo ir keturis metus tarnavo Karališkosios artilerijos ir du metus kartografijos daliniuose. Gyvendamas Kanadoje S. Prakapas aktyviai dalyvavo lietuvių visuomeninėje veikloje, dirbo redakcijoje, išleido savo prisiminimų apie karą knygą „Nuo Leningrado iki Kuršo“.",
        placeholder: "false",
      },
      {
        alive: "true",
        firstName: "Andrius",
        lastName: "Rasiulis",
        uid: "andrius_rasiulis",
        birthDate: "1955 m.",
        deathDate: "--",
        pdf: "https://www.vdkaromuziejus.lt/wp-content/uploads/2021/01/andrius_rasiulis.pdf",
        rank: "nežinoma",
        description:
          "Kanadoje gimusio ir augusio lietuviškų šaknų turinčio Andriaus Rasiulio gyvenimo istorija byloja, kad daug nuveikti savo tėvų šaliai galima ir tarnaujant svetur.<br>A. Rasiulis – tai žmogus, kuris, būdamas Kanados kariuomenės aktyviojo rezervo karininku ir kuruodamas karinių mokymų ir pagalbos programas Kanadoje, tiesiogiai prisidėjo prie Lietuvos kariuomenės atkūrimo, sudarydamas sąlygas mūsų šalies karininkams ir puskarininkiams Kanados kariuomenės mokymų centrų kursuose ne tik mokytis anglų bei prancūzų kalbų, bet ir realiai susipažinti su Vakarų valstybės, grįstos laisvės ir demokratijos principais, ilgametės NATO narės kariuomene.<br>Už nuopelnus Lietuvai A. Rasiulis buvo apdovanotas Lietuvos Respublikos krašto apsaugos sistemos medaliu civiliams.",
        placeholder: "false",
      },
      {
        alive: "true",
        firstName: "Kostas",
        lastName: "Rimša",
        uid: "kostas_rimsa",
        birthDate: "Nežinoma",
        deathDate: "--",
        pdf: "https://www.vdkaromuziejus.lt/wp-content/uploads/2021/01/kostas_rimsa.pdf",
        rank: "Majoras",
        description:
          "Tai istorija apie žmogų, kuris nuo pat mažens žinojo, kad būti kariu yra jo pašaukimas. Kostas Rimša – žvalgas, nematomas, nepastebimas, nežinomas.<br>K. Rimša gimė Kanadoje, jo senelis Kostas Ivaškevičius vienas pirmųjų Lietuvos Nepriklausomybės kovų savanorių, tėvas Zigmas Rimša buvo Lietuvos karinių oro pajėgų atsargos karininkas. K. Rimšos gyvenimas pažymėtas slaptumo žyma, nes jis ilgus metus tarnavo Kanados kariuomenėje kaip lengvasis pėstininkas ir karinės žvalgybos karininkas. K. Rimša buvo neabejingas ir savo tėvų šaliai, todėl 1991–2001 m. padėjo atkuriant Lietuvos kariuomenę ir jos specialiąsias tarnybas bei 1993 m. užtikrino popiežiaus vizito Lietuvoje apsaugą. Ypatingą reikšmę turi K. Rimšos indėlis konsultuojant ir mokant Lietuvos karius, nes tai  buvo itin svarbu siekiant užtikrinti, kad Lietuva būtų priimta į NATO.",
        placeholder: "false",
      },
      {
        alive: "true",
        firstName: "Laisvydas",
        lastName: "Baršauskas",
        uid: "laisvydas_k_a_barsauskas",
        birthDate: "1949 m.",
        deathDate: "--",
        pdf: "https://www.vdkaromuziejus.lt/wp-content/uploads/2022/06/laisvydas_k_a_barsauskas.pdf",
        rank: "Ats. plk. ltn.",
        description:
          "Tai istorija apie įspūdingą kario kelią nuėjusį, lietuvių emigrantų šeimoje gimusį, neįprasto (1,98 m) ūgio tankų ir šarvuočių dalinių karininką atsargos pulkininką leitenantą Laisvydą Kazimierą Andrių Baršauską.<br>Laisvydas gimė 1949 m. vasario 19 d. Fort Viljame, Škotijoje (Jungtinėje Karalytėje), tačiau 1950 m. Baršauskų šeima persikėlė į Kanadą, kur 1966 m. Laisvydas įstojo į Kanados kariuomenę. Karines žinias jis plėtė Kanados karininkų mokykloje. Karininkas L. Baršauskas tarnavo keturiuose šarvuočių pulkuose Kanadoje ir Vokietijoje. Be to jis tarnavo Kipre, Austrijoje, Azerbaidžane, Kosove, buvusioje Jugoslavijos Respublikoje, Makedonijoje, Bosnijoje ir Hercegovinoje, Kongo Demokratinėje Respublikoje ir JAV.<br>Plk. ltn. Laisvydas Baršauskas 37 savo gyvenimo metus paskyrė Kanados kariuomenei, per tuos metus būta įvairių nutikimų, sėkmingų ir tokių, kurie kelia šypseną iki šiol.",
        placeholder: "false",
      },
      {
        alive: "true",
        firstName: "Dainius",
        lastName: "Šileika",
        uid: "dainius_sileika",
        birthDate: "1986 m.",
        deathDate: "--",
        pdf: "https://www.vdkaromuziejus.lt/wp-content/uploads/2023/02/dainius_sileika.pdf",
        rank: "Seržantas",
        description:
          "Tai neįprasta žmogaus, kario ir Lietuvos patrioto istorija. Dainius Šileika gimė išeivių iš Lietuvos šeimoje, Kanadoje. 2006–2013 m. tarnavo Kanados kariuomenėje. Tarnybos metu išėjo įvairius kursus, tarnybą baigė turėdamas seržanto laipsnį. 2009 m. septynis mėnesius dalyvavo ISAF operacijoje „Athena“ Afganistane, Kandaharo provincijoje, kur buvo sužeistas. Grįžęs į Kanadą, baigė Paramos ginklų kursus ir tapo instruktoriumi; iki pat tarnybos pabaigos ėjo įvairias instruktoriaus pareigas.<br>Tarnaudamas kariuomenėje, su pagyrimu pabaigė McGilio universitetą, bakalauro studijas. 2013 m. nusprendė palikti Kanados kariuomenės gretas ir jau tų pačių metų viduryje persikėlė gyventi į Lietuvą. 2015 m. rugpjūčio 21 d. tapo Lietuvos kariuomenės dalimi – Krašto apsaugos savanorių pajėgų Didžiosios Kovos apygardos 8-osios rinktinės savanoriu.",
        placeholder: "false",
      },
    ],
  },
  {
    countryTag: "GBR",
    soldiers: [
      {
        placeholder: "true",
        lastName: "B",
      },
      {
        placeholder: "true",
        lastName: "K",
      },
      {
        placeholder: "true",
        lastName: "L",
      },
      {
        placeholder: "true",
        lastName: "P",
      },
      {
        placeholder: "true",
        lastName: "S",
      },
      {
        alive: "false",
        firstName: "Pranciškus",
        lastName: "Bujauskas",
        uid: "pranciskus_bujauskas",
        birthDate: "1921 m.",
        deathDate: "Nežinoma",
        pdf: "https://www.vdkaromuziejus.lt/wp-content/uploads/2023/11/pranciskus_bujauskas.pdf",
        rank: "Eilinis",
        description:
          "Pranciškus Bujauskas buvo pašauktas į britų kariuomenę 1941 m. ir paskirtas tarnauti į R. A. S. C.  (Royal Army Service Corp – Karališkosios kariuomenės tarnybos korpusas), kur buvo apmokytas kaip vairuotojas.<br>Antrojo pasaulinio karo metu Pranciškus Bujauskas dalyvavo karinėse operacijose Šiaurės Afrikoje, Italijoje, karą pabaigė Vokietijoje. Tačiau dar iki 1946 m. tarnavo britų kariuomenėje 428 ir 607 kuopose. Vėliau išleistas į atsargą dar iki 1959 m. dalyvavo britų kariuomenės organizuotuose rezervistų mokymuose.<br>Už savo tarnybą Pranciškus Bujauskas buvo apdovanotas Afrikos Žvaigžde su Pirmos Armijos juostele (The Africa Star with “1st Army” clasp), Italijos Žvaigžde (The Italy Star), 1939–45 Žvaigžde (The 1939-1945 Star) ir Karo medaliu 1939–45 (War Medal 1939-1945).<br>Dėl problemų tariant vardą ir pavardę, norėdamas neišsiskirti iš vietinių gyventojų bei apsisaugoti nuo deportacijos į Sovietų Sąjungą, pasikeitė vardą ir pavardę į Frank White.",
        placeholder: "false",
      },
      {
        alive: "false",
        firstName: "Pijus",
        lastName: "Bujauskas",
        uid: "pijus_bujauskas",
        birthDate: "1892 m.",
        deathDate: "Nežinoma",
        pdf: "https://www.vdkaromuziejus.lt/wp-content/uploads/2023/12/pijus_bujauskas.pdf",
        rank: "Eilinis",
        description:
          "Pijus Bujauskas gimė dabartinėje Šunskų parapijoje, Marijampolės rajone. Vedė vietinę Marijoną, gimus sūnui, su šeima išvyko į Didžiąją Britaniją, kur įsikūrė Glazgo mieste. Sulaukęs gausios šeimos, 8 vaikų, ja rūpinosi. 1917 m. britų vyriausybė pasirašė sutartį su Rusija dėl Rusijos piliečių, šaukiamojo amžiaus vyrų, grąžinimo. Tačiau prieš tai visiems vyrams iš Rusijos imperijos pasiūlė likti Anglijoje ir tarnauti britų kariuomenėje. Tarp 700 lietuvių, pasirinkusių tarnybą britų kariuomenėje, buvo ir Pijus Bujauskas.<br>Pijus Bujauskas tarnybą pradėjo Kalnų lengvajame pėstininkų pulke (The Highland Light Infantry Regiment), bet po kiek laiko, kai Rusijoje buvo nuverstas caras, nepasitikint išeiviais iš Rusijos, Anglijoje buvo priimtas sprendimas perkelti išeivius iš kovinių dalinių į aprūpinimo ar aptarnavimo padalinius. Taip Pijus Bujauskas 1918 m. buvo perkeltas tarnauti į Britų kariuomenės darbo korpusą.",
        placeholder: "false",
      },
      {
        alive: "false",
        firstName: "Albinas",
        lastName: "Liudžius",
        uid: "albinas_liudzius",
        birthDate: "1918 m.",
        deathDate: "1944 m.",
        pdf: "https://www.vdkaromuziejus.lt/wp-content/uploads/2021/01/albinas_liudzius.pdf",
        rank: "Seržantas",
        description:
          "Albinas Liudžius gimė 1918 m. Londone lietuvių išeivių šeimoje. Sekdamas tėvų pavyzdžiu aktyviai dalyvavo įvairių lietuviškų organizacijų veikloje. 1938 m. netgi dalyvavo Lietuvoje surengtose Pasaulio lietuvių olimpinėse žaidynėse ir dviračių sporto varžybose iškovojo sidabro medalį. Po šių žaidynių ketino likti Lietuvoje, tačiau artėjanti karo grėsmė paskatino grįžti pas tėvus į Londoną.<br>1939 m. kaip atsargos savanoris įstojo į Karališkąsias oro pajėgas, baigė pirminį treniruočių kursą Anglijoje, o 1942 m. buvo išsiųstas į Kanadą tęsti piloto studijų. 1944 m. A. Liudžius tarnavo Viduriniuose Rytuose, vėliau Italijoje, kur pilotavo naikintuvą „Mustang“. Kartu su naikintuvų „Mustang“ grupe 1944 m. rugpjūčio 25 d. dalyvavo operacijoje, o vykdant užduotį jo lėktuvas buvo numuštas zenitinės artilerijos. Laimė, jam pavyko sėkmingai iššokti su parašiutu. Jį išgelbėjo tik atsitiktinumas – nusileidus sutiko graikų partizanus, kurių padedamas sugrįžo į ekskadrilę. Sugrįžęs toliau vykdė kovinius skraidymus virš buvusios Jugoslavijos. 1944 m. lapkričio 23 d. skrydis buvo lemtingas, seržanto Albino Liudžiaus pilotuojamas naikintuvas buvo numuštas, o 26 metų amžiaus pilotas žuvo. A. Liudžius palaidotas Belgrade, britų karių kapinėse.",
        placeholder: "false",
      },
      {
        alive: "false",
        firstName: "Jonas",
        lastName: "Beinoras",
        uid: "jonas_beinoras",
        birthDate: "Nežinoma",
        deathDate: "1918 m.",
        pdf: "https://www.vdkaromuziejus.lt/wp-content/uploads/2021/01/jonas_beinoras.pdf",
        rank: "Eilinis",
        description:
          "Pirmojo Pasaulinio karo metu kartu su 5,4 mln. Jungtinės Karalystės karių Vakarų fronte Prancūzijoje ir Flandrijoje tarnavo ir eilinis lietuvių kilmės karys Jonas Beinoras. Nors trūksta duomenų apie Jono tarnybą, žinoma, kad jis tarnavo Linkolnšyro pulke ir kovėsi Vakarų fronte Prancūzijoje, kur 1918 m. gegužės 28 d. žuvo per netikėtą vokiečių kariuomenės masinę ataką, nukreiptą prieš sąjungininkių Prancūzijos ir Jungtinės Karalystės pajėgas prie Enos upės. Eilinis J. Beinoras už tarnybą buvo apdovanotas Didžiojo karo (1914–1918) ir Pergalės medaliais.",
        placeholder: "false",
      },
      {
        alive: "false",
        firstName: "Eduardas",
        lastName: "Balsavičius",
        uid: "eduardas_balsavicius",
        birthDate: "1921 m.",
        deathDate: "1981 m.",
        pdf: "https://www.vdkaromuziejus.lt/wp-content/uploads/2021/01/eduardas_balsavicius.pdf",
        rank: "Nežinoma",
        description:
          "Edis (Eduardas) buvo 18-metis, kai karas užklupo Europą. Jis 1939 m. gegužę savanoriškai įstojo į Jungtinės Karalystės kariuomenę ir buvo paskirtas į seniausią šalies Karališkųjų škotų pėstininkų pulką, kuris juokais britų karių dar buvo vadinamas Poncijaus Piloto sargybiniais. Prasidėjus karui, Edis buvo oficialiai mobilizuotas į reguliariąją kariuomenę. Iki pat 1943 m. pradžios jis tarnavo įvairiuose kariniuose vienetuose. Kadangi iki karo jis buvo įgijęs variklių inžinieriaus kvalifikaciją, tai kariuomenėje ėjo vairuotojo mechaniko pareigas.<br>1943 m. Edis buvo išsiųstas į 1-ąjį karališkąjį škotų fuzilierių batalioną Indijoje, o vėliau su kitais kariais kaip pastiprinimas buvo perkeltas į 1-ąjį kamerūniečių (angl. Cameronians) batalioną, kuris buvo žinomas kaip dar vienas labai stiprus ir kovingas Škotijos padalinys, intensyviai besiruošiantis kovoms su Japonijos kariuomenės padaliniais užnugaryje. Kovodamas toli nuo savo namų Edis pasižymėjo per karines operacijas, buvo apdovanotas Birmos žvaigžde ir 1939–1945 karo medaliu. 1946-ųjų viduryje buvo išbrauktas iš Pirmosios parengties tarnybos karių sąrašo ir iki 1958 m. buvo rezerve.",
        placeholder: "false",
      },
      {
        alive: "false",
        firstName: "Jonas M.",
        lastName: "Liudžius",
        uid: "jonas_m_liudzius",
        birthDate: "1916 m.",
        deathDate: "1999 m.",
        pdf: "https://www.vdkaromuziejus.lt/wp-content/uploads/2021/01/jonas_m_liudzius.pdf",
        rank: "Majoras",
        description:
          "Jonas Mykolas Liudžius gimė 1916 m. Londone lietuvių išeivių šeimoje. Kartu su šeima aktyviai dalyvavo vietinės lietuvių bendruomenės veikloje.<br>1940 m. J. Liudžius įstojo į kariuomenę, mokėsi karinėje mokykloje Bármute (Barmouth), Velse. 1944–1946 m. jis tarnavo kaip štabo karininkas įvairiose Vakarų Europos šalyse. Nuo 1946 m. tarnavo britų karinėje administracijoje tuometinėje Vakarų Vokietijoje, vėliau – Didžiosios Britanijos užsienio reikalų ministerijoje. Būtent šiuo metu J. Liudžius turėjo kontaktų ir su Lietuvos partizanais. 1953–1974 m. J. Liudžius ėjo įvairias pareigas Didžiosios Britanijos užsienio reikalų tarnyboje: dirbo šalies ambasadose Pietų Korėjoje, Japonijoje, Singapūre, Birmoje ir Vietname, Honkongo administracijos Politiniame skyriuje.<br>1974 m. išėjęs į pensiją J. Liudžius padėjo į anglų kalbą versti pogrindinę lietuvių spaudą, pasiekiančią Vakarus iš Sovietų Sąjungos okupuotos Lietuvos. Žymiausias jo darbas – „Kryžių šalis“ apie katalikų persekiojimą okupuotoje Lietuvoje. J. Liudžius mirė 1999 m. Jam atminti Liudžių šeimai svarbioje Londono Šv. Kazimiero lietuvių katalikų bažnyčioje atidengta memorialinė lenta.",
        placeholder: "false",
      },
      {
        alive: "false",
        firstName: "Jonas",
        lastName: "Pumeris",
        uid: "jonas_pumeris",
        birthDate: "1907 m.",
        deathDate: "1988 m.",
        pdf: "https://www.vdkaromuziejus.lt/wp-content/uploads/2021/01/jonas_pumeris.pdf",
        rank: "Eilinis",
        description:
          "Jono Pumerio gyvenimo istorija yra vienas tų pavyzdžių, kuris rodo, kad pareigą atlikti galima tarnaujant ne tik su ginklu, bet ir su muzikos instrumentu rankose.<br>Jonas Pumeris gimė 1907 m. Škotijoje, išeivių iš Lietuvos šeimoje, o būdamas aštuonerių su mama sugrįžo į Lietuvą. Užaugęs J. Pumeris įstojo į kunigų seminariją, tačiau apnikus dvejonėms paliko seminariją ir 1928 m. įstojo į Lietuvos kariuomenės gretas. Jonas turėjo muzikinę klausą ir labai norėjo tapti Lietuvos kariuomenės orkestro muzikantu. Ši jo svajonė sėkmingai išsipildė. 1928–1939 m. J. Pumeris buvo ne tik Lietuvos kariuomenės orkestro muzikantas, bet orkestranto pareigas ėjo ir Karo muziejuje bei Kauno restorane „Metropolis“.<br>Artėjančio karo akivaizdoje J. Pumeris, turėjęs Didžiosios Britanijos pilietybę, išvyko į Didžiąją Britaniją. Netrukus puskarininkis J. Pumeris buvo priimtas į seniausio Didžiosios Britanijos kariuomenės Karališkojo pulko COLDM GDS (angl. Coldsream Guards) orkestrą kaip gvardietis ir muzikantas. Didžiosios Britanijos kariuomenėje jis praleido 22 metus, su orkestru keliavo po Europą. Už tarnybą Karališkajame pulke J. Pumeris buvo apdovanotas keturiais medaliais.",
        placeholder: "false",
      },
      {
        alive: "false",
        firstName: "Jonas D.",
        lastName: "Stepsis",
        uid: "jonas_d_stepsis",
        birthDate: "1923 m.",
        deathDate: "Nežinoma",
        pdf: "https://www.vdkaromuziejus.lt/wp-content/uploads/2021/01/jonas_d_stepsis.pdf",
        rank: "Seržantas majoras",
        description:
          "Lietuviškų šaknų turintis Didžiosios Britanijos pilietis Jonas Stepsis nors buvo Jungtinės Karalystės kariuomenės karys, save laikė „civiliu su uniforma“.<br>Jonas Stepsis (visuomenėje žinomas anglišku vardu ir pavarde – John Millar) gimė 1923 m. išeivio iš Lietuvos, knygnešio Vincento Stepsio šeimoje Škotijoje. 1942 m. Jonas buvo pašauktas į Jungtinės Karalystės kariuomenę. Šaukimas į kariuomenę nelabai pradžiugino, savanoriškai į ją Jonas nesiveržė ir netgi iš pradžių šiek tiek protestavo, bet vėliau karinė tarnyba jam sekėsi labai gerai. Per ketverius tarnybos metus jis buvo gerai įvertintas ir iki tarnybos pabaigos 1946 m. jau turėjo užsitarnavęs seržanto majoro laipsnį. Vėliau savanoriu pasiprašė į Škotijos Gordono kalniečių 6-ąjį batalioną, su kuriuo buvo išsiųstas į Alžyrą (Šiaurės Afrika) ir po keleto mūšių perkeltas į Italiją, kur vyko intensyvios kautynės, o norint išlikti gyvam, kautis buvo tiesiog privalu. Jau gerokai vėliau, po karo, Jonas parašė knygą „Nėra gyvų didvyrių: nepalankaus šauktinio prisiminimai“, kurioje aprašė kovų Italijoje realybę.<br>Nors Jonas niekada negyveno Lietuvoje, paliko ryškų pėdsaką ne tik kaip karys, bet ir kaip žmogus, kuris nepamiršo savo šaknų: parašė ir publikavo darbus apie lietuvius Jungtinėje Karalystėje, o ypač vertinga yra jo knyga apie lietuvius Škotijoje.",
        placeholder: "false",
      },
      {
        alive: "false",
        firstName: "Leonas",
        lastName: "Kalinauskas",
        uid: "leonas_kalinauskas",
        birthDate: "1923 m.",
        deathDate: "1981 m.",
        pdf: "https://www.vdkaromuziejus.lt/wp-content/uploads/2021/01/leonas_kalinauskas.pdf",
        rank: "Eilinis",
        description:
          "Trumpa Leono (Leo) Kalinausko karinės tarnybos istorija parodo, kad pilietinės pareigos šiam žmogui nesutrukdė atlikti net jaunas amžius. Leonas gimė 1923 m. Londone, išeivių iš Lietuvos šeimoje. Prasidėjus Antrajam pasauliniam karui Leonas dar nebuvo sulaukęs tinkamo tarnybai amžiaus. Tik karui jau artėjant į pabaigą jis savanoriškai užsirašė į karinę tarnybą, buvo paskirtas į Jungtinės Karalystės karališkojo jūrų laivyno Jūrų aviacijos junginį ir išsiųstas į Tolimųjų Rytų karo veiksmų teatrą. Čia jis mokėsi jūrų aviacijos kario parengiamojo kurso dalykų. Leonas buvo paskirtas į lėktuvnešį „HMS Indefatigable“, tarnavo kaip oro žvalgas karo lėktuvuose „Grumman Avenger“. Tačiau L. Kalinauskas nepabaigė pasirengimo koviniams skrydžiams kurso, nes vieno mokomojo skrydžio metu lėktuvas, kuriuo jis skrido, nepasiekęs reikiamo aukščio, trenkėsi į vandenį. Lėktuvo pilotas žuvo, o Leonui pasisekė išgyventi. Karas baigėsi anksčiau, nei išsigydęs žaizdas jis galėjo vėl sugrįžti į karo operacijų rajoną. Nors ir trumpai truko Leono karinė tarnyba, tačiau jos žymės liko ilgam.",
        placeholder: "false",
      },
      {
        alive: "false",
        firstName: "Jonas",
        lastName: "Balsavičius",
        uid: "jonas_balsavicius",
        birthDate: "1911 m.",
        deathDate: "1943 m.",
        pdf: "https://www.vdkaromuziejus.lt/wp-content/uploads/2021/01/jonas_balsavicius.pdf",
        rank: "Nežinoma",
        description:
          "Jonas Balsavičius, Škotijoje žinomas Johnnie Thomson vardu, gimė 1911 m. išeivių iš Lietuvos šeimoje. 1928 m. tapo kariu, įstojo į Gordono kalniečių pulką. Iki 1930 m. pabaigos jis tarnavo 1-ojo „Gordon Highlanders“ bataliono šauliu Indijoje, Šiaurės Vakarų pasienyje, kur tuo metu dažnai tekdavo dalyvauti koviniuose veiksmuose. Jono karinė tarnyba buvo gerai įvertinta ir po 7 metų jis buvo paleistas iš reguliariosios kariuomenės. 1939 m. prasidėjus Antrajam pasauliniam karui, buvo vėl pakviestas į tarnybą.<br>1940 m. buvo perkeltas į Gordono kalniečių pulko 5/7 batalioną. Jonas dalyvavo mokymuose garsiojoje 51-ojoje kalnų divizijoje ir 1941 m. su šia divizija buvo permestas į Šiaurės Afrikos operacijų rajoną. Ten jis dalyvavo kautynėse su Italijos kariuomene, vėliau – su Vokietijos feldmaršalo Ervino Romelio Afrikos korpusu. Jonas žuvo 1943 m. vasario 26 d. Šiaurės Afrikos karinei kampanijai beveik baigiantis. Jonas palaidotas Sfakso Sandraugos karių kapinėse Tunise, Didžiojoje Britanijoje Edinburgo pilyje esančiame Karo memoriale yra įrašyta ir šio lietuvio pavardė. Jonas Balsavičius už tarnybą Jungtinės karalystės kariuomenėje buvo apdovanotas šiais kariniais apdovanojimai: 1939–1945 žvaigžde, Afrikos žvaigžde ir 1939–1945 m. karo medaliu.",
        placeholder: "false",
      },
      {
        alive: "false",
        firstName: "Stasys",
        lastName: "Balsavičius",
        uid: "stasys_balsavicius",
        birthDate: "1914 m.",
        deathDate: "1996 m.",
        pdf: "https://www.vdkaromuziejus.lt/wp-content/uploads/2021/01/stasys_balsavicius.pdf",
        rank: "Kapralas",
        description:
          "Stasys Balsavičius kaip ir brolis Jonas gimė Škotijoje, tačiau 1930 m. pabaigoje iš Škotijos persikėlė į Londono priemiestį. Jis pasekė brolio Jono pėdomis – 1940 m. balandį, kaip savanoris pradėjo tarnybą kariuomenėje ir buvo paskirtas į Karališkosios kariuomenės Aprūpinimo korpusą, kuris tuo metu buvo atsakingas už logistinę paramą Sausumos pajėgoms. Didžiojoje Britanijoje karo metu jam teko tarnauti daugelyje vietų, buvo vairuotoju, vėliau tarnavo kaip mechanikas. 1944 m. lapkritį jis buvo išsiųstas į Egiptą. Didžiąją laiko dalį tarnavo Motorinių valčių kuopoje, vėliau – Tankų transportavimo vienete. Tada jį išsiuntė į Sudaną ir priskyrė prie Sudano kariuomenės, kur buvo pakeltas į kapralus.<br>Į Didžiąją Britaniją grįžo 1946 m. vasarį. Kario tarnybos lape Stasys buvo apibūdintas kaip turintis didelę patirtį tikrinant ir remontuojant visų tipų transporto priemones. Jo elgesio įrašas rodo jį buvus labai gerą ir patikimą karį. Karui pasibaigus, iki 1954 m. jis pasiliko kaip privalomosios teritorinės kariuomenės tarnybos karys, o po karo, dar kylant įvairių neramumų, liko Sausumos pajėgų aktyviajame rezerve iki 1959 m. Už tarnybą 1940–1945 m. jis buvo apdovanotas 1939–1945 karo medaliu.",
        placeholder: "false",
      },
      {
        alive: "false",
        firstName: "Antanas",
        lastName: "Lukoševičius",
        uid: "antanas_lukosevicius",
        birthDate: "1896 m.",
        deathDate: "1980 m.",
        pdf: "",
        rank: "Eilinis",
        description:
          "Antanas Lukoševičius (Antony Lucas), kaip ir kiti Didžiojoje Britanijoje gyvenantys lietuviai, latviai, estai, rusai ir kitų tautybių emigrantai iš Rusijos imperijos, turėjo rinktis, ar eiti tarnauti į britų kariuomenę, ar būti išsiųstam atgal į Rusiją pagal Didžiosios Britanijos ir Rusijos susitarimą, pasirašytą 1917 m. Antanas Lukoševičius pasirinko stoti į britų kariuomenę ir tokių kaip jis lietuvių buvo apie 700. Čia jis prisijungė prie 51-osios karališkosios lauko artilerijos baterijos, kuri buvo 9-osios (Škotų) divizijos dalis.<br>Būdamas artileristas jis tarnavo nuo 1917 m. iki karo pabaigos. Už savo tarnybą jis buvo apdovanotas kariniu medaliu „Už drąsą“, „Britų Karo medaliu (1914–1918 m.)“ ir „Pergalės medaliu“.<br>Karinis medalis „Už drąsą“ Antanui Lukoševičiui buvo įteiktas paties Anglijos karaliaus Jurgio V.",
        placeholder: "false",
      },
    ],
  },
  {
    countryTag: "USA",
    soldiers: [
      {
        placeholder: "true",
        lastName: "B",
      },
      {
        placeholder: "true",
        lastName: "D",
      },
      {
        placeholder: "true",
        lastName: "E",
      },
      {
        placeholder: "true",
        lastName: "H",
      },
      {
        placeholder: "true",
        lastName: "J",
      },
      {
        placeholder: "true",
        lastName: "K",
      },
      {
        placeholder: "true",
        lastName: "L",
      },
      {
        placeholder: "true",
        lastName: "M",
      },
      {
        placeholder: "true",
        lastName: "S",
      },
      {
        placeholder: "true",
        lastName: "Š",
      },
      {
        placeholder: "true",
        lastName: "V",
      },
      {
        alive: "false",
        firstName: "Stenlis",
        lastName: "Benderis",
        uid: "stenlis_benderis",
        birthDate: "1909 m.",
        deathDate: "1994 m.",
        pdf: "https://www.vdkaromuziejus.lt/wp-content/uploads/2021/01/stenlis_benderis.pdf",
        rank: "Štabo seržantas",
        description:
          "Antrojo pasaulinio karo metais amerikiečių gretose kariavo įvairių tautybių kariai, kurie garsino Jungtinių Amerikos Valstijų (JAV) kariuomenę. Tačiau nedaugeliui imigrantų teko garbė būti apdovanotiems Garbės ordinu – aukščiausiu šalies kariniu apdovanojimu už narsą. Tikriausiai vienintelis toks lietuvių kilmės karys – štabo seržantas Stenlis Benderis (Stanley Bender).<br>1939 m. jis užsirašė į JAV sausumos kariuomenę ir pasakė: „Siųskite mane taip toli, kaip galite.“ Kariuomenei šis lietuviškų šaknų turinčio piliečio noras buvo priimtinas. JAV įsitraukus į karą, S. Benderis  kartu su JAV sausumos kariuomenės vienu iš pėstininkų pulku buvo pasiųstas į Europą ir nuo 1942 m. dalyvavo mūšiuose. 1944 m. Stenlis su savo padaliniu išsilaipino Prancūzijos pietinėje dalyje ir dalyvavo operacijoje „Dragoon“. Nuopelnus, už kuriuos S. Benderis gavo Garbės  ordiną, geriausiai įvardijo JAV prezidentas Franklinas Ruzveltas: „Už nepaprastą narsą ir drąsą rizikuojant savo gyvybe iš pareigos jausmo.[...] Jo ryžtas taip įkvėpė puolančius kuopos karius, kad vyrai iššoko iš savo pozicijų ir puolė šaukdami. [...]  Jis taip pat paskatino kuopą ir pats vadovavo puolimui, per kurį priešas buvo nugalėtas.“<br>Kalbant apie jo karinius nuopelnus, Stenlis visada buvo kuklus. Kai kas nors paklausdavo, ką jis padarė, kad nusipelnė tokios pagarbos, jis atsakydavo, kad padarė tai, ką tokiomis aplinkybėmis padarytų kiekvienas.",
        placeholder: "false",
      },
      {
        alive: "false",
        firstName: "Zenonas",
        lastName: "Lukošius",
        uid: "zenonas_lukosius",
        birthDate: "1919 m.",
        deathDate: "2006 m.",
        pdf: "https://www.vdkaromuziejus.lt/wp-content/uploads/2021/01/zenonas_lukosius.pdf",
        rank: "Jūreivis",
        description:
          "Apie Antrojo pasaulinio karo veteraną lietuvį emigrantą Zenoną Lukošių yra girdėję milijonai žmonių. Per Antrąjį pasaulinį karą dėl jūreivio Z. Lukošiaus pasiaukojimo amerikiečiams atiteko puikus karo grobis – nacistinės Vokietijos povandeninis laivas U-505. Už tai jis pelnė vieną aukščiausių Jungtinių Amerikos Valstijų (JAV) apdovanojimų už narsą – Sidabrinės žvaigždės medalį.<br>Zenonas gimė lietuvių emigrantų šeimoje. Jis, kaip ir jo jaunesnysis brolis Leo, norėjo tarnauti kariniame laivyne, bet motinai paliepus tą galėjo padaryti tik tada, kai į namus sugrįžo tarnybą atlikęs brolis.<br>Z. Lukošius tarnybą atliko karo laive „Pillsbury“, kuriam buvo pavesta perimti aptikto vokiečių povandeninio laivo kontrolę. Vokiečiai, prieš palikdami povandeninį laivą, atvėrė liukus ir vandens vožtuvus, kad laivas nuskęstų, tačiau Z. Lukošius juos uždarė ir taip išgelbėjo JAV karo laivyno grobiu tapusį vokiečių povandeninį laivą. Šis laimikis buvo labai vertingas, nes buvo aptikta svarbios žvalgybinės medžiagos, kuri padėjo atskleisti nemažai Vokietijos karinių paslapčių.<br>Išėjęs į atsargą, Z. Lukošius nuolatos kartodavo, kad jis nėra herojus, jis tik jūreivis, padaręs darbą, kuriam buvo rengiamas.",
        placeholder: "false",
      },
      {
        alive: "false",
        firstName: "Petras M.",
        lastName: "Moncevičius",
        uid: "petras_m_moncevicius",
        birthDate: "1898 m.",
        deathDate: "1978 m.",
        pdf: "https://www.vdkaromuziejus.lt/wp-content/uploads/2021/01/petras_m_moncevicius.pdf",
        rank: "Kontradmirolas",
        description:
          "Petras M. Moncevičius (Peter Michael Moncy) gimė lietuvių imigrantų Moncevičių šeimoje. 1921 m. P. M. Moncevičius tapo JAV karinio jūrų laivyno leitenantu. Nuo 1929 m. iki 1930 m. jis tarnavo jūrų operacijų padalinio viršininku Vašingtone, į šias pareigas kartu įėjo ir tarnyba Baltuosiuose rūmuose – jis buvo JAV prezidento Herbeto Huverio (Herbet Hoover) padėjėju karinio jūrų laivyno klausimais.<br>JAV įsitraukus į Antrąjį pasaulinį karą, P. M. Moncevičius buvo paskirtas naftos tankerio vadu. Jo vadovaujamas laivas veikė Atlanto vandenyne ir kartu su kitais laivais pristatydavo šio regiono JAV kariniams daliniam reikalingas karines atsargas. 1942 m. į P. M. Moncevičiaus vadovaujamą laivą pataikė torpeda ir pažeidė bortą. Tuo metu laivas gabeno aviacinius degalus, alyvą ir giluminius užtaisus, laivas atsidūrė katastrofiškoje padėtyje: 4 įgulos nariai žuvo, degalai tryško ant pabūklų, tačiau laivo vado komandos ir puikūs įgūdžiai užtikrino laimingą baigtį. Už drąsius ir efektyvius veiksmus tarnaujant šiame laive  kontradmirolas P. M. Moncevičius buvo apdovanotas antru pagal svarbą JAV kariniu apdovanojimu – Karinio jūrų laivyno kryžiumi.<br>Pasibaigus karui P. M. Moncevičius tarnavo toliau, 1948 m. buvo paskirtas Jungtinių Tautų stebėtoju Palestinoje. Prieš išeidamas į atsargą kontradmirolas 1952 m. ėjo JAV Pirmojo karinių jūrų laivyno rajono štabo viršininko pareigas bei vadovavo pagalbos misijai Kosta Rikoje.<br>Vertindama kontradmirolo pasiaukojimą ir pagarbą lietuviškai kilmei, Amerikos lietuvių bendruomenė 1956 m. jį išrinko Lietuvos riterių metų žmogumi.",
        placeholder: "false",
      },
      {
        alive: "true",
        firstName: "Frankas",
        lastName: "Šimokaitis",
        uid: "frankas_simokaitis",
        birthDate: "1922 m.",
        deathDate: "--",
        pdf: "https://www.vdkaromuziejus.lt/wp-content/uploads/2021/01/frankas_simokaitis.pdf",
        rank: "Generolas majoras",
        description:
          "Bebaimis lietuviškų šaknų turintis pilotas, praskraidęs daugiau nei 3500 valandų, valdęs daugiau nei 10 įvairių tipų orlaivių, apdovanotas įvairiais medaliais, taip pat ir pripažintas JAV teismų srityse – tai Frankas J. Šimokaitis.<br>Būsimas Jungtinių Amerikos Valstijų (JAV) generolas majoras tarnybą JAV karinėse pajėgose pradėjo 1942 m., mokėsi būti pilotu, 1943 m. gavo jaunesniojo leitenanto laipsnį. Leiko Čarlso sausumos kariuomenės aerodromas Luizianos valstijoje buvo pirmoji operacinė tarnybos vieta, čia jis ėjo bombonešio B-26 piloto pareigas, vėliau tapo instruktoriumi, o dar po kiek laiko – 478-osios bombardavimo eskadrilės skrydžio įgulos vadu.<br>Antrojo pasaulinio karo metu F. J. Šimokaitis buvo perkeltas į Europą, kur atliko 27 kovinius skrydžius. 1945 m. išleistas iš aktyvios tarnybos, mokėsi Teisės mokykloje, bet greitai vėl buvo priimtas į nuolatinę tarnybą, 1950 m. baigė Specialiųjų tyrimų mokyklą, pradėjo eiti specialiųjų tyrimų karininko pareigas Vysbadene (Wiesbaden), Vokietijoje.<br>1953 m. grįžo į JAV, toliau tęsė mokslus, vėliau tarnavo Havajuose. 1973 m. suteiktas generolo majoro laipsnis, nuo 1973 m. F. J. Šimokaitis vadovavo JAV karinių oro pajėgų Technologijos institutui, o 1976 m. tapo pirmuoju Saugumo paramos valdybos Gynybos instituto viršininku.",
        placeholder: "false",
      },
      {
        alive: "false",
        firstName: "Ana A.",
        lastName: "Bernatitus",
        uid: "ana_a_bernatitus",
        birthDate: "1912 m.",
        deathDate: "2003 m.",
        pdf: "https://www.vdkaromuziejus.lt/wp-content/uploads/2021/01/ana_a_bernatitus.pdf",
        rank: "Jūrų kapitonė",
        description:
          "Karai visada suprantami kaip „vyrų reikalas“, tačiau jie niekada neapsieidavo ir be moterų – jos rūpindavosi sužeistaisiais. Tokia buvo ir Ana Agnesė Bernatitus.<br>Nuo pat mažens Ana sakydavo, kad nori dirbti arba mokytoja, arba medicinos seserimi. Siekdama savo svajonės, Ana baigė mokslus ir užsirašė į JAV karinio jūrų laivyno Slaugos korpusą. 1936 m. išlaikė fizinio parengimo testus ir tapo JAV karinio jūrų laivyno Slaugos korpuso karininke. Nuo tada ji 23 metus rūpinosi sužeistaisiais ir ligoniais, kol galiausiai užsitarnavo karinio laivyno jūrų kapitono laipsnį.<br>Tarnaudama Ana garsėjo kaip labai gera medicinos sesuo, besirūpinanti sergančiais ir sužeistais kariais, vėliau ji ėmėsi darbo terapijos, kad padėtų sužeistiesiems grįžti į normalų civilinį gyvenimą. Jos darbai ir patirtis per Antrąjį pasaulinį karą minimi iki šiol, ji yra ir pirmoji iš visų JAV karių apdovanota Nusipelniusio legionieriaus medaliu.",
        placeholder: "false",
      },
      {
        alive: "false",
        firstName: "Frederikas E.",
        lastName: "Bakutis",
        uid: "frederikas_e_bakutis",
        birthDate: "1912 m.",
        deathDate: "2009 m.",
        pdf: "https://www.vdkaromuziejus.lt/wp-content/uploads/2021/01/frederikas_e_bakutis.pdf",
        rank: "Kontradmirolas",
        description:
          "Tarp Antrojo pasaulinio karo dalyvių galima rasti ne vieną lietuviškų šaknų turintį didvyrį. Prie tokių priskiriamas ir Frederikas Edvardas Bakutis.<br>Jis – pilotas asas, per Antrąjį pasaulinį karą numušė 11 Japonijos karo lėktuvų, pats irgi buvo pamuštas virš vandenyno, bet po savaitės išgelbėtas. Vėliau vadovavo operacinėms jūrų pajėgoms abiejuose Žemės pusrutuliuose, išbandė pirmuosius JAV reaktyvinius lėktuvus ir vadovavo JAV astronautų bei jų modulių paieškos ir paėmimo iš vandenyno operacijoms.<br>Kontradmirolas yra vienintelis istorijoje karinių jūrų laivynų pareigūnas, vadovavęs šiaurinio ir pietinio pusrutulių operatyvinėms pajėgoms: būdamas Havajų jūros sienos vadu jis tuo pat metu vadovavo Aliaskos jūros ir Antarktidos jūros sienoms. Už didvyrišką tarnybą F. E. Bakutis buvo apdovanotas ir daugybe medalių, svarbiausi iš jų – Karinio jūrų laivyno kryžius, Nusipelniusio legionieriaus medalis, Kryžius už pasižymėjimą teikiant oro paramą, Nacionalinės aeronautikos ir kosmoso administracijos medalis už išskirtinę tarnybą.",
        placeholder: "false",
      },
      {
        alive: "false",
        firstName: "Steponas",
        lastName: "Darius",
        uid: "steponas_darius",
        birthDate: "1897 m.",
        deathDate: "1933 m.",
        pdf: "https://www.vdkaromuziejus.lt/wp-content/uploads/2021/01/steponas_darius.pdf",
        rank: "Grandinis",
        description:
          "1933 metų liepos 14 d. Niujorko orų tarnyboje buvo sulaukta geros žinios – skirsti galima. Jau kitos dienos ryte, 6 val. 24 min. S. Darius ir S. Girėnas pakilo iš Niujorko Floido Beneto (Floyd Bennet Field) oro uosto, taip pradėdami vieną žymiausių kelionių istorijoje. Nepaisant to, kad šis įvykis labiausiai ir išgarsino lakūnus, jų asmenybės yra kur kas labiau įvairiapusės.<br>Steponas Darius, be žymaus skrydžio, žinomas kaip Lietuvos kariuomenės karininkas, lakūnas, Klaipėdos krašto vaduotojas, krepšinio ir kitų sporto šakų Lietuvoje pradininkas, pirmojo Lietuvoje stadiono projektuotojas ir jo statybos darbų prižiūrėtojas, Lietuvos fizinio lavinimo sąjungos pirmininkas. Mažiau kam žinomas faktas ir tai, kad 1917 m. balandžio 6 d. JAV paskelbus karą Vokietijai, S. Darius pasiryžo stoti į JAV karių gretas, kur buvo paskirtas JAV Vaivorykštės divizijos Lauko artilerijos pulko telefonininku. Už sąžiningą tarnybą JAV kariuomenėje buvo apdovanotas medaliu „Purpurinė širdis“.",
        placeholder: "false",
      },
      {
        alive: "false",
        firstName: "Tadas",
        lastName: "Kosciuška",
        uid: "tadas_kosciuska",
        birthDate: "1746 m.",
        deathDate: "1817 m.",
        pdf: "https://www.vdkaromuziejus.lt/wp-content/uploads/2021/01/tadas_kosciuska.pdf",
        rank: "Generolas",
        description:
          "Vienu žymiausiu laisvės simboliu galima vadinti Tadą Kosciušką. Jis – karo vadas ir politikas, kovojęs už amerikiečių, lietuvių, lenkų tautų laisvę, siekęs pasaulyje įgyvendinti Apšvietos amžiaus laisvės ir lygybės idealus. Amerikos ir Abiejų Tautų Respublikos kariuomenių generolas, revoliucinės Prancūzijos garbės pilietis, 1794 m. ėjęs Lenkijos ir Lietuvos valstybės vadovo – aukščiausiojo viršininko – pareigas.<br>T. Kosciuškos vardas siejamas su laisvės ir lygybės idėjomis ne tik Lietuvoje bei Lenkijoje, bet ir visame pasaulyje. Jis buvo minimas anglų poeto Džordžo Bairono eilėraštyje, prancūzų rašytojo Žiulio Verno romane. Kosciuškos vardu pavadinta ir sala, grafystė, miestas bei aukščiausias Australijos kalnas.",
        placeholder: "false",
      },
      {
        alive: "false",
        firstName: "Edvardas",
        lastName: "Jasaitis",
        uid: "edvardas_jasaitis",
        birthDate: "1936 m.",
        deathDate: "2000 m.",
        pdf: "https://www.vdkaromuziejus.lt/wp-content/uploads/2021/01/edvardas_jasaitis.pdf",
        rank: "Pulkininkas leitenantas",
        description:
          "Išeivių iš Lietuvos vaikas, būsimasis JAV karininkas ir profesorius Edvardas Jasaitis jau būdamas 18-os tvirtai žinojo –  jis nori tarnauti JAV kariuomenėje. Atkakliai siekęs šios svajonės 1958 m. baigė JAV karo akademiją ir atitarnavęs pėstininkų būrio vadu Miunchene (Vokietijoje), nusprendė eiti toliau – įstojo į JAV specialiąsias pajėgas. JAV kariuomenėje jis tarnavo iki 1982 m. Per dvidešimt ketverius karinės tarnybos metus jis ėjo įvairias pareigas tiek kariuomenės štabuose, tiek padaliniuose kaip vadas. Tarnybos geografija taip pat plati – JAV, Vokietija, Vietnamas ir Korėja.<br>Pabaigęs tarnybą JAV, sugrįžo į gimtąją Lietuvą, kur pradėjo organizuoti viešojo administravimo studijas, jo iniciatyva Kauno technologijos universitete buvo įkurta Viešojo administravimo katedra.<br>Pulkininkas leitenantas E. Jasaitis yra apdovanotas medaliu „Purpurinė širdis“, Pėstininko kovos ženklu, Vietnamo Respublikos kryžiumi už narsą su sidabrine žvaigžde, Parašiutininko meistro ženklu ir kitais apdovanojimais.",
        placeholder: "false",
      },
      {
        alive: "false",
        firstName: "Juozas",
        lastName: "Manelis",
        uid: "juozas_manelis",
        birthDate: "1935 m.",
        deathDate: "1986 m.",
        pdf: "https://www.vdkaromuziejus.lt/wp-content/uploads/2021/01/juozas_manelis.pdf",
        rank: "Pulkininkas",
        description:
          "Išeivis iš Lietuvos Juozas Manelis savo tarnystę paskyrė žmonėms – jis nusprendė prisidėti prie JAV saugumo užtikrinimo gelbstint gyvybes. Būsimojo pulkininko, gydytojo kardiochirurgo, medicinos daktaro, profesoriaus J. Manelio šeima 1944 m. pasitraukė į Vokietiją, o 1948 m. – į JAV. Čia 1952 m. jis baigė Marianapolio mokyklą, o vėliau Ilinojaus universitetą, kuriame studijavo filosofiją ir mediciną. Medicinos centruose dėstė širdies ir kraujagyslių chirurgijos disciplinas.<br>1960 m. pradėjęs karinę tarnybą JAV kariuomenėje, dirbo chirurgu bei vadovavo JAV kariuomenės ligoninei ir jos Chirurgijos skyriui Saigone (Vietname). 1983 m. jam buvo suteiktas pulkininko laipsnis. J. Manelis tyrė lazerio taikymą kardiochirurgijoje bei tobulino chirurgijos techniką – visa tai panaudojo ir gydydamas JAV kariuomenės karius.",
        placeholder: "false",
      },
      {
        alive: "false",
        firstName: "Vladislovas",
        lastName: "Sabaliauskas",
        uid: "vladislovas_sabaliauskas",
        birthDate: "1910 m.",
        deathDate: "1993 m.",
        pdf: "https://www.vdkaromuziejus.lt/wp-content/uploads/2021/01/vladislovas_sabaliauskas.pdf",
        rank: "Seržantas majoras",
        description:
          "„Sab vyrams buvo kaip tėvas“ – taip apie išeivį iš Lietuvos Vladislovą Sabaliauską atsiliepė jo kolega. V. Sabaliauskas Jungtinių Amerikos Valstijų kariuomenėje tarnavo tris dešimtmečius – nuo 1941 m. iki 1972 m. Karinę tarnybą pradėjo nuo eilinio, baigė – būdamas vadovybės seržantu majoru, išplėtė ir savo tarnybos geografiją – JAV, Filipinai, Vakarų Vokietija, Dominikos Respublika, Pietų Vietnamas.<br>Už savo nuopelnus ir pasiekimus JAV kariuomenėje V. Sabaliauskas buvo vadinamas „karių kariu“ arba „didžiai apdovanotu kariu“, tarp gausybės karinių apdovanojimų jo kolekcijoje puikuojasi keturi medaliai „Purpurinė širdis“, taip pat antras pagal svarbą JAV karinis apdovanojimas – Karinių pajėgų kryžius, įteiktas už ypatingą narsą rizikuojant savo gyvybe mūšyje. Taip pat jo vardu  JAV yra pavadintas vienas iš kariuomenės desantininkų mokymo centrų.",
        placeholder: "false",
      },
      {
        alive: "true",
        firstName: "Romanas A.",
        lastName: "Sedlickas",
        uid: "romanas_a_sedlickas",
        birthDate: "1942 m.",
        deathDate: "--",
        pdf: "https://www.vdkaromuziejus.lt/wp-content/uploads/2021/01/romanas_a_sedlickas.pdf",
        rank: "Majoras",
        description:
          "„Teko gaudyti barškuoles ir jomis maitintis, praleisti ilgas savaites giliose pelkėse, tankumynuose, kur visi biesai slypi“ – taip apie savo tarnybos pradžią Jungtinių Amerikos Valstijų (JAV) kariuomenėje kalba Romanas Algimantas Sedlickas –  JAV lietuvių ir Lietuvos politinis bei visuomenės veikėjas, Vietnamo karo dalyvis. R. A. Sedlickas baigęs mokslus tarnavo JAV karinėse oro pajėgose Vietname, ši patirtis, pasak Romano, jį neišdildomai paženklino ir pakeitė jo mąstyseną. Šios tarnybos metu buvo apdovanotas bronzinės žvaigždės ordinu (Bronze Star Medal). Vėliau pradėjo advokato karjerą, o Lietuvai atkūrus Nepriklausomybę – sugrįžo į Lietuvą ir aktyviai įsitraukė į politinį jos gyvenimą.",
        placeholder: "false",
      },
      {
        alive: "true",
        firstName: "Herbertas",
        lastName: "Šiugžda",
        uid: "herbertas_siugzda",
        birthDate: "1943 m.",
        deathDate: "--",
        pdf: "https://www.vdkaromuziejus.lt/wp-content/uploads/2021/01/herbertas_siugzda.pdf",
        rank: "Viršila",
        description:
          "Tai istorija apie ypatingos drąsos lietuvį Herbertą Šiugždą – virėją tapusį vienu iš slaptų projektų Project Delta kariu. Kaip pats Herbertas pasakoja, jo tarnybos pradžia JAV specialiosiose pajėgose nebuvo lengva, jis savanoriškai įstojo į JAV kariuomenę 1962 m., gebėjimų testo balai buvo žemi, todėl gavo virėjo specialybę ir buvo išsiųstas į Okinavą tarnauti virėju su Specialiųjų pajėgų kuopa. Šiuo laikotarpiu pasiruošė perlaikyti gebėjimų testą – antrą kartą testą pavyko išlaikyti gana gerai ir tik po to buvo priimtas į Specialiąsias pajėgas. Vardan to teko atsisakyti Lietuvos pilietybės, nes Specialiosios pajėgos – vienintelis karinis vienetas, kur reikalaujama turėti JAV pilietybę. Jis, atlikdamas tarnybą viename iš slapčiausių sausumos kariuomenės žvalgybos dalinių Vietname, užtikrino radijo ryšį su priešakine baze, kelis kartus buvo sunkiai sužeistas, o už pasiaukojimą ir heroizmą atliekant pareigas – apdovanotas.",
        placeholder: "false",
      },
      {
        alive: "true",
        firstName: "Romas",
        lastName: "Kilikauskas",
        uid: "romas_kilikauskas",
        birthDate: "1936 m.",
        deathDate: "--",
        pdf: "https://www.vdkaromuziejus.lt/wp-content/uploads/2021/01/romas_kilikauskas.pdf",
        rank: "Pulkininkas",
        description:
          "Būsimojo JAV žvalgybos pulkininko Romo Kilikausko šeima 1944 m. pasitraukė į Vokietiją, 1954 m. – į JAV. Tais pačiais metais R. Kilikauskas įstojo į Amerikos karių gretas. Kadangi puikiai mokėjo lietuvių, vokiečių ir rusų kalbas, tapo žvalgybos operacijų specialistu ir lingvistu. Jam teko tarnauti ir Vietnamo kare, o vėlesnė tarnybos trajektorija apėmė Vokietiją ir JAV. 1989 m. jam buvo suteiktas JAV karinių oro pajėgų pulkininko laipsnis. Nuo 1990 m. iki 1992 m. R. Kilikauskas dirbo Pentagone – Gynybos žvalgybos agentūroje, kur buvo atsakingu už JAV Gynybos departamento įspėjimo sistemą, iš kurios informaciją gaudavo JAV Baltieji rūmai, kariuomenės vadas.<br>Po 37 tarnybos metų, 1992 m. išėjo į atsargą ir įsitraukė į atkuriamos Lietuvos reikalus – tapo JAV ambasadoriaus kariniu patarėju, atsakingu už Rusijos karinių pajėgų išvedimo iš Lietuvos stebėseną, vėliau dirbo vidaus reikalų viceministru, Krašto apsaugos viceministru, kartu su gen. mjr.  Jonu Kronkaičiu rūpinosi Lietuvos kariuomenės modernizavimu bei ruošė ją narystei NATO.",
        placeholder: "false",
      },
      {
        alive: "true",
        firstName: "Jonas",
        lastName: "Kronkaitis",
        uid: "jonas_kronkaitis",
        birthDate: "1935 m.",
        deathDate: "--",
        pdf: "https://www.vdkaromuziejus.lt/wp-content/uploads/2021/01/jonas_kronkaitis.pdf",
        rank: "Pulkininkas (JAV), Generolas majoras (Lietuva)",
        description:
          "Jonas Kronkaitis – tai generolas, kuris puikiai prisimena Vietnamo karą. Generolas, kuris mano, kad blogiausia pasaulyje nutinka tada, kada pradeda kariauti politikai. Generolas, kuris siekė, kad mūsų kariuomenė, būdama NATO narė, sugebėtų apginti Lietuvą. Generolas, kuris sako „Kad  vadai mūšius gali pralaimėti, o juos laimėti gali tik kariai. Karys – svarbiausias kariuomenės asmuo, ne ginklai, ne šautuvai, ne tankai, ne lėktuvai, bet karys, kuris tą ginklą naudoja, yra kariuomenės jėga.“<br>JAV pulkininkas ir Lietuvos generolas majoras J. Kronkaitis taip save pristato: „Kadangi net 27 metus tarnavau Amerikos karinėje sistemoje, esu įgijęs puikią vadybos ir karinę patirtį – nuo būrio vado iki pareigų Pentagone, Generalinio inspektoriaus štabe. Visos turimos žinios man labai pravertė tiek dirbant krašto apsaugos viceministru, tiek būnant kariuomenės vadu. Dveji metai Vietname ir treji Generalinio inspektoriaus štabe suteikė ne tik gerą karinę perspektyvą taktiniu, operatyviniu bei strateginiu lygmeniu, bet ir išugdė moralines vertybes, kad galėčiau sėkmingai vadovauti.“",
        placeholder: "false",
      },
      {
        alive: "true",
        firstName: "Donatas",
        lastName: "Skučas",
        uid: "donatas_skucas",
        birthDate: "1935 m.",
        deathDate: "--",
        pdf: "https://www.vdkaromuziejus.lt/wp-content/uploads/2021/01/donatas_skucas.pdf",
        rank: "Pulkininkas leitenantas",
        description:
          "„Kaip lakūnui, neteko dalyvauti jokiuose mūšiuose ar kovose, niekur narsiai nekovojau ir nepasižymėjau kaip koks didvyris. Gal tik skraidydamas parodžiau ypatingus sugebėjimus ir labai šaltą būdą. Nors buvau apdovanotas keturiolika medalių, neteikiu jiems ypatingos reikšmės. Man daugiau reiškia apdovanojimas Lietuvos „Plieno sparnai“. Visą gyvenimą sąžiningai ir ištikimai tarnavau JAV aviacijoje. Ar skrisdamas, ar dirdamas štabe, stengiausi atlikti savo užduotis kuo geriausiai, niekada neužmiršdamas savo kilmės“ – yra sakęs  JAV kariuomenės pulkininkas leitenantas Donatas Skučas.<br>Į JAV karininkų gretas Donatas Skučas įstojo 1957 m., buvo paskirtas į oro pajėgų bazę, kur skraidyti pradėjo su transporto lėktuvu C-130, o baigė su C-5 gigantu, tuo metu didžiausiu lėktuvu pasaulyje. D. Skučas praskraidė įspūdingai daug – 7 tūkstančius 330 valandų ir 36 minutes! „Apskridau pasaulį vieną kartą, nuolat skrisdamas į rytus“ – yra sakęs D. Skučas.<br>Vietnamo karo metu D. Skučo kroviniais buvo ne tik dėžės, bet ir šunys bei sužeisti ir žuvę kariai. Per karą gabendamas krovinius išbuvo dar beveik tūkstantį skrydžio valandų.<br>1982 m. išėjęs į atsargą ir aktyviai įsiliejo į JAV lietuvių bendruomenės veiklą, kartu su kitais iš Baltijos valstybių kilusiais JAV karininkais, Vašingtone įsteigė Baltijos institutą, kurio tikslas buvo padėti išsilaisvinti Baltijos šalims ir prisidėti prie kariuomenių atkūrimo, ėjo Lietuvos Respublikos krašto apsaugos ministro patarėjo pareigas.",
        placeholder: "false",
      },
      {
        alive: "true",
        firstName: "Romualdas",
        lastName: "Kriaučiūnas",
        uid: "romualdas_kriauciunas",
        birthDate: "1936 m.",
        deathDate: "--",
        pdf: "https://www.vdkaromuziejus.lt/wp-content/uploads/2021/01/romualdas_kriauciunas.pdf",
        rank: "Eilinis",
        description:
          "Romualdas Kriaučiūnas – daktaras, klinikinės psichologijos specialistas, tarnavęs Jungtinių Amerikos Valstijų kariuomenėje nors ir nebuvo apdovanotas aukščiausiais kariniais apdovanojimais, tačiau savo tarnybą atliko puikiai ir buvo įvertintas. Į JAV kariuomenę R. Kriaučiūnas buvo pašauktas 1958 m. Po pradinių mokymų buvo paskirtas į JAV Sausumos pajėgų Medikų korpusą, vėliau paskirtas į Fort Gordono kariuomenės ligoninę, Džordžijos valstijoje.<br>Už puikų pareigų atlikimą, buvo nominuotas ir Fort Gordono karinės bazės mėnesio kareiviu, o tuo metu bazėje tarnavo per 16 tūkstančių karių.  Per dvejus aktyvios tarnybos JAV kariuomenėje metus R. Kriaučiūnas buvo skatintas kelis kartus. Išėjęs į atsargą nemažai metų dirbo su emociškai traumuotais kariuomenės veteranais bei aktyviai įsitraukė į JAV lietuvių bendruomenės veiklą.",
        placeholder: "false",
      },
      {
        alive: "true",
        firstName: "Kęstutis",
        lastName: "Eidukonis",
        uid: "kestutis_eidukonis",
        birthDate: "Nežinoma",
        deathDate: "--",
        pdf: "https://www.vdkaromuziejus.lt/wp-content/uploads/2021/01/kestutis_eidukonis.pdf",
        rank: "Pulkininkas leitenantas",
        description:
          "Kęstutis Eidukonis – ilgametis Pasaulio lietuvių bendruomenės komisijos narys, istorikas, ekonomistas, karininkas, tarnavęs visų rūšių JAV kariuomenės pajėgose. Tarnaudamas JAV kariuomenėje, atliko pareigas Vokietijoje, Vietname ir Panamoje. Buvo apdovanotas sausumos, oro pajėgų, laivyno ir jūrų pėstininkų apdovanojimais, tačiau vienu didžiausių pasiekimų K. Eidukonis laiko pagalbą atkuriant Panamos vyriausybę.",
        placeholder: "false",
      },
      {
        alive: "false",
        firstName: "Anthony B.",
        lastName: "Herbert",
        uid: "anthony_b_herbert",
        birthDate: "1930 m.",
        deathDate: "2014 m.",
        pdf: "https://www.vdkaromuziejus.lt/wp-content/uploads/2021/01/anthony_b_herbert.pdf",
        rank: "Pulkininkas leitenantas",
        description:
          "Anthony B. Herbert – JAV karininkas, kurio nuopelnai ne tik nenusakomai stebina, bet ir priverčia susimąstyti, ar vienas žmogus yra pajėgus šitiek pasiekti karinėje tarnyboje. Anthony tarnybai paaukojo beveik ketvirtį savo amžiaus: 23 metų tapo jauniausiu JAV Sausumos pajėgų viršila, Korėjos kare buvo nominuotas daugiausia apdovanoto seržantų korpuso kario vardo kategorijoje, nuo eilinio kario sugebėjo pakilti iki pulkininko leitenanto. Negana to, po karinės tarnybos jis tapo klinikinės psichologijos mokslų daktaru ir išleido tris knygas – vieną apie išgyvenimą, kitas apie karišką gyvenimą ir patirtį tarnaujant JAV kariuomenėje. Vis dėlto labiausiai žinomas dėl to, kad buvo pirmasis, iškėlęs į viešumą karo nusikaltimų Vietname klausimą.",
        placeholder: "false",
      },
      {
        alive: "false",
        firstName: "Romanas",
        lastName: "Biliūnas",
        uid: "romanas_biliunas",
        birthDate: "1932 m.",
        deathDate: "2006 m.",
        pdf: "https://www.vdkaromuziejus.lt/wp-content/uploads/2021/01/romanas_biliunas.pdf",
        rank: "Pulkininkas",
        description:
          "Romanas Biliūnas nuo vaikystės svajojo tapti lakūnu. Todėl tik atvykus į JAV, jis pradėjo karinę tarnybą – 1950 m. dalyvavo pradinio karinio rengimo kurse Laklando karinių oro pajėgų bazėje. JAV karinėse pajėgose atitarnavęs 36 metus, išėjo į atsargą. Per tarnybos laikotarpį buvo paskirtas tarnauti į Vietnamą ir Europą, kur dirbo JAV ir NATO institucijose.",
        placeholder: "false",
      },
      {
        alive: "false",
        firstName: "Donatas",
        lastName: "Banaitis",
        uid: "donatas_banaitis",
        birthDate: "1942 m.",
        deathDate: "Nežinoma",
        pdf: "https://www.vdkaromuziejus.lt/wp-content/uploads/2021/01/donatas_banaitis.pdf",
        rank: "Penktos klasės specialistas",
        description:
          "Donatas Banaitis į JAV atvyko 1951 m. Karinę tarnybą atliko JAV parašiutininkų batalione. Buvo išsiųstas į karą Vietname. Už sėkmingą tarnybą ir žygdarbius buvo apdovanotas JAV Sidabrinės žvaigždės medaliu. Baigęs karinę tarnybą, D. Banaitis įstojo į Long Ailando universitetą ir sėkmingai jį baigė. Dirbo Niujorko Socialinės apsaugos administracijoje, prisidėjo prie Tautos fondo valdybos ir lietuvių veiklos JAV.",
        placeholder: "false",
      },
      {
        alive: "false",
        firstName: "Gediminas J.",
        lastName: "Eidukaitis",
        uid: "gediminas_j_eidukaitis",
        birthDate: "1939 m.",
        deathDate: "1967 m.",
        pdf: "https://www.vdkaromuziejus.lt/wp-content/uploads/2021/01/gediminas_j_eidukaitis.pdf",
        rank: "Puskarininkis",
        description:
          "Neabejojama, kad Gediminas Just Eidukaitis buvo profesionalas – jo krūtinę puošė 27 medaliai už įvairius kovinius pasiekimus. Tarnybą G. J. Eidukaitis pasirinko atlikti JAV Sausumos pajėgų aviacijoje. Išmoko skraidyti sraigtasparniu ir buvo pasiųstas į karą Vietname. Ten jis buvo sužeistas, tačiau nenurimo ir po kurio laiko vėl ėmė pilotuoti sraigtasparnį. Deja, vėliau tai lėmė jo žūtį – likus dviem savaitėms iki tarnybos Vietname pabaigos jis žuvo aviakatastrofoje.",
        placeholder: "false",
      },
      {
        alive: "false",
        firstName: "Jeronimas E.",
        lastName: "Verbyla",
        uid: "jeronimas_e_verbyla",
        birthDate: "1920 m.",
        deathDate: "2013 m.",
        pdf: "",
        rank: "Vyresnysis eilinis",
        description:
          "Jeronimas Verbyla (Jerome E. Werbela) į JAV kariuomenę įstojo 1942 m. liepos 29 d. Savanoriu užsirašė į parašiutininkų rengimo kursus, po apmokymų tarnavo 101-osios divizijos 506-ojo parašiutininkų pulko 2-ojo bataliono D kuopoje kaip lengvasis kulkosvaidininkas. 506-asis parašiutininkų pulkas buvo įsteigtas 1942 m. Džordžijos valstijoje ir rengtas Tokoa bazėje. Čia būsimieji parašiutininkai susidūrė su rūsčiu pratybų kursu. Iš šių karių buvo numatyta padaryti tikrus profesionalus, galinčius sėkmingai kovoti puolant pačiame smaigalyje, veikti žaibiškai ir savarankiškai. Būtent tarp šių karių buvo ir Jeronimas Verbyla. Jis tarnavo Europoje nuo išsilaipinimo Normandijoje (dar vadinamos D dienos) iki Hitlerio Erelio lizdo Berchtesgadene užgrobimo.<br>Jeronimas Verbyla buvo paskirtas vadinamųjų „pathfinder‘ių“ vedlių operatorių sargybiniu. Šiems kariams kaunantis buvo lemta būti pirmaisiais desantininkais. Jų misija buvo pastatyti aukščiausio lygio slaptus radarų siųstuvus, vadinamus „Eureka“, kartu su „Holophane“ žibintais.<br>Už savo tarnybą Jeronimas Verbyla buvo apdovanotas du kartus Bronzine žvaigžde, Europos, Afrikos ir Artimųjų rytų kompanijos medaliu su keturiomis žvaigždėmis, Pavyzdinės tarnybos medaliu, Antrojo pasaulinio karo pergalės medaliu, Pėstininko kovos ženklu, Parašiutininko ženklu.",
        placeholder: "false",
      },
      {
        alive: "false",
        firstName: "Jurgis",
        lastName: "Sniečkus",
        uid: "jurgis_snieckus",
        birthDate: "1922 m.",
        deathDate: "1944 m.",
        pdf: "https://www.vdkaromuziejus.lt/wp-content/uploads/2022/06/du_broliai.pdf",
        rank: "Štabo seržantas",
        description:
          "Prasidėjus Antrajam pasauliniam karui ir JAV 1941 m. įsitraukus į jį, 1942 m. iš nedidelio Springfildo miesto į kariuomenę pašaukiamas Jurgis Sniečkus (George Sneckus). Po bazinio kario kurso buvo paskirtas į JAV sausumos pajėgų oro korpusą. Tarnaudamas Laurio oro pajėgų bazėje, Kolorado valstijoje buvo atrinktas į sunkiojo bombonešio B-17 Boing Flying Fortress kulkosvaidininko pareigas.<br>1944 m. kovą, jau kaip štabo seržantas Jurgis Sniečkus buvo perkeltas į Angliją, kur pradžioje buvo paskirtas į JAV kariuomenės oro korpuso 4-ą paieškos atakos eskadrilę, bet jau 1944 m. gegužės 5 d. perkeltas į JAV 8-ojo oro korpuso 100-ąją bombonešio grupę, kuri buvo įsikūrusi Thorpe Abbots aerodrome, rytų Anglijoje.<br>Iš čia 100-oji bombonešių grupė kartu su kitomis britų ir amerikiečių grupėmis vykdė dieninius ir naktinius oro antskrydžius virš Vokietijos ir Prancūzijos teritorijų. Lemtingą 1944 m. gegužės 24 d. 100-oji bombonešių grupė pakilo bombarduoti Berlyno, deja, skrendančius jau virš šiaurės Vokietijos juos užpuolė vokiečių naikintuvai, jie numušė du bombonešius, kurie nukrito 200 metrų atstumu vienas nuo kito, iš abiejų įgulų neišgyveno nė vienas, taip pat ir štabo seržantas Jurgis Sniečkus.",
        placeholder: "false",
      },
      {
        alive: "false",
        firstName: "Julius",
        lastName: "Sniečkus",
        uid: "julius_snieckus",
        birthDate: "1920 m.",
        deathDate: "1994 m.",
        pdf: "https://www.vdkaromuziejus.lt/wp-content/uploads/2022/06/du_broliai.pdf",
        rank: "Štabo seržantas",
        description:
          "1940 m. baigęs mokyklą Julius Sniečkus savanoriu užsirašė į JAV jūrų pėstininkų korpusą. Baigęs bazinį jūrų pėstininko kursą, tarnybą tęsė viename iš batalionų Camp Pendleton bazėje, Kalifornijoje.<br>Prasidėjus kariniams veiksmams Ramiajame vandenyne, JAV jūrų pėstininkai buvo išsiųsti į frontą. Per keturis kovos metus štabo seržantas Julius Sniečkus dalyvavo trijuose stambiuose koviniuose išsilaipinimuose: Samoa, Maršalo salyne, Gvadalkanalio saloje (Guadalcanal).<br>Per savo tarnybą št. srž. Julius Sniečkus buvo ne kartą apdovanotas, Asiatic Pacific Campaign Medal wit two Bronze stars (dar vadinamom Battle stars – kovos žvagždėmis), Navy Unit Commendation Medal, The US Marine Corps Good Conduct award, American Defence Medal, WWII Victory Medal.",
        placeholder: "false",
      },
      {
        alive: "false",
        firstName: "Albertas J.",
        lastName: "Kuprys",
        uid: "albertas_j_kuprys",
        birthDate: "1929 m.",
        deathDate: "2008 m.",
        pdf: "https://www.vdkaromuziejus.lt/wp-content/uploads/2022/06/albertas_j_kuprys.pdf",
        rank: "Kapralas",
        description:
          "Prasidėjus karui Korėjos pusiasalyje, Jungtinės Amerikos Valstijos įsitraukė į šį konfliktą kaip Jungtinių Tautų pajėgų dalis. 1951 m. sausio 5 d. Ilinojaus valstijoje buvo pašauktas ir Albertas Juozapas Kuprys. Kadangi turėjo elektros prietaisų operatoriaus kvalifikaciją, buvo nukreiptas į JAV sausumos pajėgų inžinerinius dalinius. Pabaigęs bazinius kario ir inžinieriaus kursus Sent Luiso mokymo centre išvyko į Korėjos pusiasalį.<br>Korėjos kare kapralas Albertas J. Kuprys praleido beveik 12 mėnesių, po to dar 5 metus tarnavo aktyviojo rezervo JAV sausumos pajėgų 5-osios armijos 574-ajame inžinieriniame korpuse. Karo inžinieriai aktyviai dalyvavo Korėjos karo veiksmuose – tiek priešakinėse linijose naikinant tiltus ir kitus komunikacijos objektus (o tai leido JT pajėgoms persigrupuoti ir pereiti į puolimą), tiek ir užnugaryje įrengiant gynybines pozicijas.<br>Už savo tarnybą kapralas Albertas J. Kuprys buvo apdovanotas Pėstininkų kovos ženklu. Po misijos jam buvo įteiktas JT medalis ir Tarnybos Korėjoje medalis su bronzine žvaigžde.",
        placeholder: "false",
      },
      {
        alive: "false",
        firstName: "Edvardas",
        lastName: "Vaitkus",
        uid: "edvardas_vaitkus",
        birthDate: "1919 m.",
        deathDate: "1972 m.",
        pdf: "",
        rank: "Seržantas",
        description:
          "Edvardas Vaitkus (Eddie Waitkus) gimė 1919 m. rugsėjo 4 d. lietuvių išeivių šeimoje Bostone, JAV. Užaugo Bostono apylinkėse, ten pabaigė mokyklą ir koledžą. Nuo vaikystės domėjosi beisbolu ir būdamas devyniolikos pradėjo profesionalo karjerą.<br>Deja, prasidėjęs Antrasis pasaulinis karas nutraukė sporto varžybas ir Edvardas Vaitkus buvo pašauktas tarnauti į JAV kariuomenę. Po bazinio mokymo Fort Devense buvo priskirtas į 544-ą inžinerinį valčių ir pakrantės pulką, kuris per San Franciską buvo perkeltas į Naująją Gvinėją. Daugiau nei metus praleido puolimo operacijose kaip kulkosvaidininkas, dalyvavo išlaisvinant Naujosios Gvinėjos salas ir vaduojant Filipinų salas nuo japonų karių.<br>Per savo tarnybą JAV kariuomenėje Edvardas Vaitkus buvo apdovanotas įvairiais medaliais: Luzonos kompanijos bronzine žvaigžde, Naujosios Gvinėjos bronzine žvaigžde, Šiaurinio Solomono bronzine žvaigžde, Azijos-Ramiojo vandenyno kompanijos medaliu bei Antrojo pasaulinio karo pergalės medaliu su bronziniu strėlės antgaliu.<br>Grįžęs iš karo toliau tęsė sportininko karjerą, tapo gerai žinomu beisbolininku, kuris iki 1955 m. sužaidė daugiau kaip 1100 rungtynių aukščiausioje JAV beisbolo lygoje.<br>Mirė 1972 m. rugsėjo 16 d. pralaimėjęs kovą su vėžiu, palaidotas Kembridžo kapinėse, Bostone.",
        placeholder: "false",
      },
    ],
  },
  {
    countryTag: "VEN",
    soldiers: [
      {
        placeholder: "true",
        lastName: "B",
      },
      {
        alive: "true",
        firstName: "Boris",
        lastName: "Petrasevičius",
        uid: "boris_petrasevicius",
        birthDate: "1943 m.",
        deathDate: "--",
        pdf: "https://www.vdkaromuziejus.lt/wp-content/uploads/2023/02/boris_petrasevicius.pdf",
        rank: "Majoras",
        description:
          "Tai istorija apie vienintelį Venesuelos kariuomenėje tarnavusį svetimtautį – lietuvį Borį (Boleslovą) Petrasevičių.<br>Boris gimė Gudų kaime (Kelmės r.), tačiau 1943 m., artėjant sovietų tankams, šeima su kelerių metų Boriu nusprendė emigruoti į Vakarus, pradžioje į Vokietiją, vėliau – į Venesuelą, kuri ir tapo šeimos namais. Venesueloje baigęs Karo muzikos mokyklą, grojo saksofonu kariniame orkestre, tačiau supratęs, kad muzikanto karjera kariuomenėje neįmanoma, įstojo į Puskarininkių mokyklą, vėliau – į Karo akademiją, kurioje pagal įstatymus mokytis gali tik gimę Venesueloje. Todėl B. Petrasevičius buvo vienintelis europietis, baigęs šią akademiją, ir vienintelis šios šalies kariuomenėje tarnaujantis svetimtautis! Patyręs iššūkių ir išbandymų, turėdamas majoro laipsnį ir apdovanotas už garbingą tarnybą Boris paliko kariuomenę.<br>Boris niekada nepamiršo savo gimtosios žemės, todėl tapo Lietuvos garbės konsulu Venesueloje ir iki šiol šioje šalyje padeda lietuviams.",
        placeholder: "false",
      },
    ],
  },
  {
    countryTag: "FRA",
    soldiers: [
      {
        placeholder: "true",
        lastName: "Z",
      },
      {
        alive: "true",
        firstName: "Vaidotas",
        lastName: "Zinkevičius",
        uid: "vaidotas_zinkevicius",
        birthDate: "1973 m.",
        deathDate: "--",
        pdf: "",
        rank: "Adjutantas",
        description:
          "1993 m. pradžioje pasiėmęs akademines atostogas išvyko pakeliauti po Europą. Pasisvečiavęs Vokietijoje ir Didžioje Britanijoje, atvyko į Prancūziją. Jau pirmajame mieste, Lile, užėjo pasiklausti kelio į Užsieniečių legiono verbavimo punktą. Legione liko 18 metų.<br>Atranką praėjo šalia Marselio, kur dvi savaites vyko fizinio pasirengimo ir psichologiniai testai, buvo tikrinama sveikata, atliekamas asmens patikimumo (biografijos) patikrinimas nuo gimimo iki patikrinimo dienos. Po pirminės atrankos patenka į vadinamąją „fermą“, kur daroma dar viena atranka, dabar jau trunkanti iki keturių mėnesių. Šios atrankos metu kandidatai mokėsi prancūzų kalbos, rikiuotės elementų, pažinti ginkluotę, fizinio rengimo ir kiekvieno mėnesio pabaigoje vykdydavo į 50 km žygį, kurį turėjo atlikti per nustatytą laiką. Po keturių mėnesių kandidatai turėjo įveikti 120 km su visa ekipuote. Visi kandidatai buvo reitinguojami, tad pirmi legionieriai galėjo pasirinkti tarnybos vietą ten, kur buvo laisvų etatų legiono pulkuose.<br>Vaidotas Zinkevičius, kaip pabaigęs kartu su geriausiais, gavo pasiūlymą likti atrankos centre ir čia dvejus metus būti vienu iš instruktorių, po to rinktis tarnybos vietą bet kuriame legiono pulke. Deja, praėjus mažiau nei dviem metams, 1995 m. liepą Vaidotas Zinkevičius tiesiai iš manevrų buvo išsiųstas į buvusią Jugoslaviją, kur Bosnijoje ir Hercegovinoje vykdė įvairias užduotis prie sostinės Sarajevo.  Gruodį pasibaigus misijai sugrįžo atgal į Marselį ir 1996 m. kovo mėnesį buvo pervestas 3-iąjį legiono pėstininkų pulką, dislokuotą Pietų Amerikoje, Prancūzijos Gvianoje.<br>Tik ką atvykusiems legionieriams yra pravedamas trumpas kursas apie džiungles, kurso pabaigoje visi eina į trijų dienų žygį. Pirmą dieną eina, antrą dieną mokosi išgyventi toje vietoje, kurioje yra, ir trečią dieną vėl žygiuoja. Legionierių šioje šalyje užduotys: saugoti Europos kosmoso agentūros (EKA, angl. European Space Agency (ESA), pranc. – Agence Spatiale Europenne (ASE) raketų paleidimo aikštelę Kuru kosmodrome Prancūzijos Gvianoje, stebėti sieną su Brazilija, giliai džiunglėse taisyti sienos riboženklius, iki kurių nueiti užtrukdavo savaitę ar daugiau, bei kovoti su nelegaliais aukso ieškotojais.<br>Po kiek laiko tarnybos Vaidotas Zinkevičius užsirašė į Komandosų mokyklą, mokėsi išgyventi džiunglėse. Mokslai truko 6 savaites, iš kurių pirmas keturias – teorinis ir praktinis mokymas, penktoji savaitė skirta praktikai: klausytojai nuplukdomi gilyn į džiungles ir savaitei laiko paliekami. Šeštoji savaitė skirta laivybai jūroje ir džiunglių upėse, klausytojai įgydavo žinių ir praktikos, kaip vairuoti greitaeigį katerį ir valtį, naviguoti džiunglėse. Pabaigus šiuos kursus Vaidotui Zinkevičiui buvo suteikta džiunglių žvalgo specialybė. Jis pervestas tarnauti į 3-iojo legiono pėstininkų pulko štabą. Kur, be savo pareigų, buvo dar ir štabo žvalgas.<br>1998 m. birželį sugrįžta į Europą, paskiriamas į Legiono štabą dirbti kaip IT specialistas. Nuo 2000–2012 m. Vaidotas Zinkevičius tarnavo įvairiose pozicijose, baigė specialistų ir vadų rengimo kursus. Viena iš pozicijų buvo atstovauti Legionui ir dirbti su personalo duomenimis: suskaitmenino visas Legiono sausumos pajėgų asmenines bylas.<br>Per savo tarnybą adjutantas Vaidotas Zinkevičius buvo apdovanotas: Medaille de Reconnaissance de la Nation (Tautos Padėkos medaliu), Medaille De La Defense Nationale 1 Bar ~ Legion Etrangere (Gynybos ministerijos medaliu su Legiono juostele), UN Protection Force Medal (JT apsaugos pajėgų medaliu); Medaille Commemorative Francaise (Prancūzijos Atminimo medaliu), Croix du combattant (Kovotojo Kryžiumi).",
        placeholder: "false",
      },
    ],
  },
];

function redirectToHttps() {
  if (window.location.protocol == "http:") {
    window.location.href = window.location.href.replace("http:", "https:");
  }
}

redirectToHttps();

function changeActiveCountryFill() {
  countryTags.forEach(function (tag) {
    document.getElementById("path" + tag).style.fill = "rgba(75, 79, 0, 0.8)";
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", afterLoaded);
} else {
  changeActiveCountryFill();
}

//Open modal
function openModal() {
  isModalOpen = true;
  modal.style.display = "block";
  map.classList.add("blured");
  addClassToDom("btnAboutProject", "btn-about-project-temp");
  removeClassFromDom("btnAboutProject", "btn-about-project");
  setTimeout(function () {
    addClassToDom("btnAboutProject", "btn-about-project");
    removeClassFromDom("btnAboutProject", "btn-about-project-temp");
  }, 100);
}

function closeModal() {
  isModalOpen = false;
  modal.style.display = "none";
  map.classList.remove("blured");
}

//Map Navigation
countryTags.forEach(function (tag) {
  document.getElementById("path" + tag).addEventListener("click", function () {
    showOverlay(true, tag);
  });
  document
    .getElementById("path" + tag)
    .addEventListener("mouseenter", function () {
      highlightCountry(tag);
    });
  document
    .getElementById("btn" + tag)
    .addEventListener("mouseenter", function () {
      highlightCountry(tag, false);
    });
  document
    .getElementById("path" + tag)
    .addEventListener("mouseleave", function () {
      resetCountry(tag);
    });
  document
    .getElementById("btn" + tag)
    .addEventListener("mouseleave", function () {
      resetCountry(tag);
    });
});

//Map Country Highlight
function highlightCountry(tag, isHovering) {
  isHovering = isHovering !== false;
  if (menuState === 0) {
    let country = document.getElementById("path" + tag);
    country.style.fill = "rgba(207, 207, 76,0.8)";
    if (isHovering) {
      infoBox.style.display = "block";
      switch (tag) {
        case "GBR":
          infoBox.innerHTML =
            '<span class="flag-icon flag-icon-gb flag-btn"></span>Jungtinė Karalystė';
          break;
        case "USA":
          infoBox.innerHTML =
            '<span class="flag-icon flag-icon-us flag-btn"></span>Jungtinės Amerikos Valstijos';
          break;
        case "CAN":
          infoBox.innerHTML =
            '<span class="flag-icon flag-icon-ca flag-btn"></span>Kanada';
          break;
        case "VEN":
          infoBox.innerHTML =
            '<span class="flag-icon flag-icon-ve flag-btn"></span>Venesuela';
          break;
        case "FRA":
          infoBox.innerHTML =
            '<span class="flag-icon flag-icon-fr flag-btn"></span>Prancūzija';
          break;
      }
    }
  }
}

window.onmousemove = function getPointerPosition(event) {
  let x = event.clientX;
  let y = event.clientY;
  infoBox.style.left = x - infoBox.offsetWidth / 2 + "px";
  infoBox.style.top = y - infoBox.offsetHeight - 20 + "px";
};

function resetCountry(tag) {
  let country = document.getElementById("path" + tag);
  country.style.fill = "rgba(75, 79, 0, 0.8)";
  infoBox.style.display = "none";
}

function showOverlay(inMainMenu, tag) {
  countryTag = tag;
  document.getElementById("overlayMask").style.width = "100%";
  if (inMainMenu) {
    if (isCountryNavOpen) {
      closeCountryNav();
    }
    setTimeout(function () {
      openSoldierPanel();
    }, 500);
  } else {
    if (isSoldierNavOpen) {
      closeSoldierNav();
    }
    addClassToDom("btnGoBack", "btn-go-back-temp");
    removeClassFromDom("btnGoBack", "btn-go-back");
    setTimeout(function () {
      addClassToDom("btnGoBack", "btn-go-back");
      removeClassFromDom("btnGoBack", "btn-go-back-temp");
    }, 100);
    setTimeout(function () {
      closeSoldierPanel();
    }, 500);
  }
}

function openSoldierPanel() {
  menuState = 1;
  infoBox.style.display = "none";
  soldierObj.forEach(function (element) {
    if (element.countryTag == countryTag) {
      soldierData = element.soldiers.sort(function (a, b) {
        return ("" + a["lastName"]).localeCompare(b["lastName"], "lt", {
          sensitivity: "base",
        });
      });
      for (let i = 0; i < soldierData.length; i++) {
        if (soldierData[i].placeholder === "true") {
          let tempButton = document.createElement("a");
          tempButton.classList.add("btn-soldier-placeholder");
          tempButton.innerText = "- " + soldierData[i].lastName;
          soldierNavbar.appendChild(tempButton);
        } else if (soldierData[i].placeholder === "false") {
          let tempButton = document.createElement("a");
          tempButton.id = "";
          if (loadedDom < 1) {
            loadedDom = 1;
            tempButton.classList.add("btn-soldier", "btn-active");
          } else {
            tempButton.classList.add("btn-soldier");
          }
          tempButton.innerText =
            soldierData[i].lastName + " " + soldierData[i].firstName;
          tempButton.setAttribute("id", i);
          tempButton.addEventListener("click", function () {
            let tempID = this.id;
            selectSoldier(tempID, false);
          });
          soldierNavbar.appendChild(tempButton);
          soldierButtons.push(tempButton);
        }
      }
    }
  });
  switch (countryTag) {
    case "GBR":
      countryName.innerHTML =
        '<span class="flag-icon flag-icon-gb flag-soldier-name"></span>Jungtinė Karalystė';
      break;
    case "USA":
      countryName.innerHTML =
        '<span class="flag-icon flag-icon-us flag-soldier-name"></span>Jungtinės Amerikos Valstijos';
      break;
    case "CAN":
      countryName.innerHTML =
        '<span class="flag-icon flag-icon-ca flag-soldier-name"></span>Kanada';
      break;
    case "VEN":
      countryName.innerHTML =
        '<span class="flag-icon flag-icon-ve flag-soldier-name"></span>Venesuela';
      break;
    case "FRA":
      countryName.innerHTML =
        '<span class="flag-icon flag-icon-fr flag-soldier-name"></span>Prancūzija';
      break;
  }
  moveToTop();
  document.getElementById("mainMenu").style.display = "none";
  map.classList.add("blured");
  document.getElementById("btnAboutProject").style.display = "none";
  document.getElementById("btnCountryMenu").style.display = "none";
  credits.style.display = "none";
  document.getElementById("btnGoBack").style.display = "block";
  document.getElementById("soldierPanel").style.display = "block";
  document.getElementById("btnSoldierMenu").style.display = "block";
  selectSoldier(1, true);
}

//Country navigation bar
function openCountryNav() {
  if (!isCountryNavOpen) {
    countryNavbar.style.display = "block";
    addClassToDom("btnCountryMenu", "btn-country-menu-temp");
    removeClassFromDom("btnCountryMenu", "btn-country-menu");
    setTimeout(function () {
      addClassToDom("btnCountryMenu", "btn-country-menu");
      removeClassFromDom("btnCountryMenu", "btn-country-menu-temp");
      showCountryNav();
    }, 100);
  }
}

function showCountryNav() {
  countryNavbar.style.width = "300px";
  sidenavDummy.style.display = "block";
  setTimeout(function () {
    setCountryNavStatus(true);
  }, 400);
}

function closeCountryNav() {
  if (isCountryNavOpen) {
    countryNavbar.style.width = "0";
    sidenavDummy.style.display = "none";
    setTimeout(hideCountryNav, 500);
  }
}

function hideCountryNav() {
  countryNavbar.style.display = "none";
  setCountryNavStatus(false);
}

function setCountryNavStatus(isOpen) {
  isCountryNavOpen = isOpen;
}

//Soldier navigation bar
function openSoldierNav() {
  if (!isSoldierNavOpen) {
    soldierNavbar.style.display = "block";
    addClassToDom("btnSoldierMenu", "btn-soldier-menu-temp");
    removeClassFromDom("btnSoldierMenu", "btn-soldier-menu");
    setTimeout(function () {
      addClassToDom("btnSoldierMenu", "btn-soldier-menu");
      removeClassFromDom("btnSoldierMenu", "btn-soldier-menu-temp");
      showSoldierNav();
    }, 100);
  }
}

function showSoldierNav() {
  soldierNavbar.style.width = "300px";
  sidenavDummy.style.display = "block";
  setTimeout(function () {
    setSoldierNavStatus(true);
  }, 400);
}

function closeSoldierNav() {
  if (isSoldierNavOpen) {
    soldierNavbar.style.width = "0";
    sidenavDummy.style.display = "none";
    setTimeout(hideSoldierNav, 500);
  }
}

function hideSoldierNav() {
  soldierNavbar.style.display = "none";
  setSoldierNavStatus(false);
}

function setSoldierNavStatus(isOpen) {
  isSoldierNavOpen = isOpen;
}

//Click anywhere outside of sidenav and close it
window.onclick = function (event) {
  if (event.target === sidenavDummy && isSoldierNavOpen) {
    closeSoldierNav();
  } else if (event.target === sidenavDummy && isCountryNavOpen) {
    closeCountryNav();
  } else if (event.target === modal && isModalOpen) {
    closeModal();
  }
};

//Close soldier panel
function closeSoldierPanel() {
  menuState = 0;
  loadedDom = 0;
  soldierButtons = [];
  document.getElementById("overlayMask").style.width = "0";
  if (window.innerWidth < 895) {
    document.getElementById("mainMenu").style.display = "block";
    document.getElementById("btnCountryMenu").style.display = "none";
  } else {
    document.getElementById("btnCountryMenu").style.display = "block";
  }
  map.classList.remove("blured");
  document.getElementById("btnAboutProject").style.display = "block";
  credits.style.display = "block";
  document.getElementById("btnGoBack").style.display = "none";
  document.getElementById("soldierPanel").style.display = "none";
  document.getElementById("btnSoldierMenu").style.display = "none";
  currentPdfUrl = "";
  if (!NodeList.prototype.forEach && Array.prototype.forEach) {
    NodeList.prototype.forEach = Array.prototype.forEach;
  }
  document.querySelectorAll(".btn-soldier").forEach(function (element) {
    return element.parentNode.removeChild(element);
  });
  document
    .querySelectorAll(".btn-soldier-placeholder")
    .forEach(function (element) {
      return element.parentNode.removeChild(element);
    });
  soldierData = {};
}

//Select soldier
function selectSoldier(soldierID, firstRun) {
  firstRun = firstRun !== false;
  moveToTop();
  soldierImage.src = imgPlaceholder.src;
  soldierFullName.innerText =
    soldierData[soldierID].firstName + " " + soldierData[soldierID].lastName;
  soldierImage.setAttribute(
    "src",
    "images/" + countryTag + "/" + soldierData[soldierID].uid + ".jpg"
  );
  soldierBirthDate.innerText = "Gime: " + soldierData[soldierID].birthDate;
  soldierDeathDate.innerText = "Mirė: " + soldierData[soldierID].deathDate;
  if (soldierData[soldierID].alive === "true") {
    document.getElementById("soldierInfoDeathDate").style.display = "none";
  } else if (soldierData[soldierID].alive === "false") {
    document.getElementById("soldierInfoDeathDate").style.display = "block";
  }
  soldierRank.innerText = "Laipsnis: " + soldierData[soldierID].rank;
  soldierDescription.innerText = soldierData[soldierID].description;
  document.getElementById("soldierDescription").innerHTML = document
    .getElementById("soldierDescription")
    .innerText.replace(/<br>/g, "<br><br>");
  // console.log(currentPdfUrl);
  currentPdfUrl = soldierData[soldierID].pdf;
  const tempPdfButton = document.querySelector(".soldier-button");
  if (currentPdfUrl.length === 0) {
    tempPdfButton.classList.add("inactive");
    tempPdfButton.textContent = "Nėra informacijos";
  } else {
    if (tempPdfButton.classList.contains("inactive"))
      tempPdfButton.classList.remove("inactive");
    tempPdfButton.textContent = "Žiūrėti plačiau";
  }
  if (firstRun) {
    document.getElementById("overlayMask").style.width = "0";
  } else {
    document.querySelectorAll(".btn-soldier").forEach(function (element) {
      return element.classList.remove("btn-active");
    });
    document.getElementById(soldierID).classList.add("btn-active");
  }
}

//Open soldier's pdf file in a new tab
function openPdf() {
  window.open(currentPdfUrl, "_blank");
}

//Select soldier
function moveToTop() {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
}

function switchNavigation() {
  if (window.innerWidth < 895 && menuState === 0) {
    document.getElementById("mainMenu").style.display = "block";
    map.style.display = "none";
    document.getElementById("btnCountryMenu").style.display = "none";
    if (isCountryNavOpen) closeCountryNav();
  } else if (window.innerWidth > 895 && menuState === 0) {
    document.getElementById("mainMenu").style.display = "none";
    map.style.display = "block";
    document.getElementById("btnCountryMenu").style.display = "block";
  } else if (window.innerWidth < 895 && menuState === 1) {
    map.style.display = "none";
  } else if (window.innerWidth > 895 && menuState === 1) {
    map.style.display = "block";
  }
}

// function resizeMobileBackground() {
//   backgroundGrid.offsetHeight = window.innerHeight + 120;
//   backgroundGradient.offsetHeight = window.innerHeight + 120;
// }

// resizeMobileBackground();

//Check for Country Nav during window resize
window.onresize = function () {
  //   resizeMobileBackground();
  switchNavigation();
};

function getBrowser() {
  if (/MSIE \d|Trident.*rv:/.test(navigator.userAgent)) {
    window.location = "microsoft-edge:" + window.location;
    setTimeout(function () {
      window.location = "https://go.microsoft.com/fwlink/?linkid=2135547";
    }, 1);
  }
}

getBrowser();

function getWindowLocationPath() {
  const queryString = window.location.search;
  const urlSearchParams = new URLSearchParams(queryString);
  const soldier = urlSearchParams.get("soldier");

  // Pranciskus Bujauskas
  if (soldier === "gbr_pranciskus_bujauskas") {
    countryTag = "GBR";
    //
    menuState = 1;
    infoBox.style.display = "none";
    soldierObj.forEach(function (element) {
      if (element.countryTag == countryTag) {
        soldierData = element.soldiers.sort(function (a, b) {
          return ("" + a["lastName"]).localeCompare(b["lastName"], "lt", {
            sensitivity: "base",
          });
        });
        for (let i = 0; i < soldierData.length; i++) {
          if (soldierData[i].placeholder === "true") {
            let tempButton = document.createElement("a");
            tempButton.classList.add("btn-soldier-placeholder");
            tempButton.innerText = "- " + soldierData[i].lastName;
            soldierNavbar.appendChild(tempButton);
          } else if (soldierData[i].placeholder === "false") {
            let tempButton = document.createElement("a");
            tempButton.id = "";
            if (loadedDom < 1) {
              loadedDom = 1;
              tempButton.classList.add("btn-soldier", "btn-active");
            } else {
              tempButton.classList.add("btn-soldier");
            }
            tempButton.innerText =
              soldierData[i].lastName + " " + soldierData[i].firstName;
            tempButton.setAttribute("id", i);
            tempButton.addEventListener("click", function () {
              let tempID = this.id;
              selectSoldier(tempID, false);
            });
            soldierNavbar.appendChild(tempButton);
            soldierButtons.push(tempButton);
          }
        }
      }
    });
    switch (countryTag) {
      case "GBR":
        countryName.innerHTML =
          '<span class="flag-icon flag-icon-gb flag-soldier-name"></span>Jungtinė Karalystė';
        break;
      case "USA":
        countryName.innerHTML =
          '<span class="flag-icon flag-icon-us flag-soldier-name"></span>Jungtinės Amerikos Valstijos';
        break;
      case "CAN":
        countryName.innerHTML =
          '<span class="flag-icon flag-icon-ca flag-soldier-name"></span>Kanada';
        break;
      case "VEN":
        countryName.innerHTML =
          '<span class="flag-icon flag-icon-ve flag-soldier-name"></span>Venesuela';
        break;
      case "FRA":
        countryName.innerHTML =
          '<span class="flag-icon flag-icon-fr flag-soldier-name"></span>Prancūzija';
        break;
    }
    moveToTop();
    document.getElementById("mainMenu").style.display = "none";
    map.classList.add("blured");
    document.getElementById("btnAboutProject").style.display = "none";
    document.getElementById("btnCountryMenu").style.display = "none";
    credits.style.display = "none";
    document.getElementById("btnGoBack").style.display = "block";
    document.getElementById("soldierPanel").style.display = "block";
    document.getElementById("btnSoldierMenu").style.display = "block";
    selectSoldier(5, false);
    //
    document.querySelectorAll(".btn-soldier").forEach(function (element) {
      return element.classList.remove("btn-active");
    });
    document.getElementById(5).classList.add("btn-active");
  }

  // Pijus Bujauskas
  if (soldier === "gbr_pijus_bujauskas") {
    countryTag = "GBR";
    //
    menuState = 1;
    infoBox.style.display = "none";
    soldierObj.forEach(function (element) {
      if (element.countryTag == countryTag) {
        soldierData = element.soldiers.sort(function (a, b) {
          return ("" + a["lastName"]).localeCompare(b["lastName"], "lt", {
            sensitivity: "base",
          });
        });
        for (let i = 0; i < soldierData.length; i++) {
          if (soldierData[i].placeholder === "true") {
            let tempButton = document.createElement("a");
            tempButton.classList.add("btn-soldier-placeholder");
            tempButton.innerText = "- " + soldierData[i].lastName;
            soldierNavbar.appendChild(tempButton);
          } else if (soldierData[i].placeholder === "false") {
            let tempButton = document.createElement("a");
            tempButton.id = "";
            if (loadedDom < 1) {
              loadedDom = 1;
              tempButton.classList.add("btn-soldier", "btn-active");
            } else {
              tempButton.classList.add("btn-soldier");
            }
            tempButton.innerText =
              soldierData[i].lastName + " " + soldierData[i].firstName;
            tempButton.setAttribute("id", i);
            tempButton.addEventListener("click", function () {
              let tempID = this.id;
              selectSoldier(tempID, false);
            });
            soldierNavbar.appendChild(tempButton);
            soldierButtons.push(tempButton);
          }
        }
      }
    });
    switch (countryTag) {
      case "GBR":
        countryName.innerHTML =
          '<span class="flag-icon flag-icon-gb flag-soldier-name"></span>Jungtinė Karalystė';
        break;
      case "USA":
        countryName.innerHTML =
          '<span class="flag-icon flag-icon-us flag-soldier-name"></span>Jungtinės Amerikos Valstijos';
        break;
      case "CAN":
        countryName.innerHTML =
          '<span class="flag-icon flag-icon-ca flag-soldier-name"></span>Kanada';
        break;
      case "VEN":
        countryName.innerHTML =
          '<span class="flag-icon flag-icon-ve flag-soldier-name"></span>Venesuela';
        break;
      case "FRA":
        countryName.innerHTML =
          '<span class="flag-icon flag-icon-fr flag-soldier-name"></span>Prancūzija';
        break;
    }
    moveToTop();
    document.getElementById("mainMenu").style.display = "none";
    map.classList.add("blured");
    document.getElementById("btnAboutProject").style.display = "none";
    document.getElementById("btnCountryMenu").style.display = "none";
    credits.style.display = "none";
    document.getElementById("btnGoBack").style.display = "block";
    document.getElementById("soldierPanel").style.display = "block";
    document.getElementById("btnSoldierMenu").style.display = "block";
    selectSoldier(6, false);
    //
    document.querySelectorAll(".btn-soldier").forEach(function (element) {
      return element.classList.remove("btn-active");
    });
    document.getElementById(6).classList.add("btn-active");
  }

  // Edvardas Vaitkus
  if (soldier === "usa_edvardas_vaitkus") {
    countryTag = "USA";
    //
    menuState = 1;
    infoBox.style.display = "none";
    soldierObj.forEach(function (element) {
      if (element.countryTag == countryTag) {
        soldierData = element.soldiers.sort(function (a, b) {
          return ("" + a["lastName"]).localeCompare(b["lastName"], "lt", {
            sensitivity: "base",
          });
        });
        for (let i = 0; i < soldierData.length; i++) {
          if (soldierData[i].placeholder === "true") {
            let tempButton = document.createElement("a");
            tempButton.classList.add("btn-soldier-placeholder");
            tempButton.innerText = "- " + soldierData[i].lastName;
            soldierNavbar.appendChild(tempButton);
          } else if (soldierData[i].placeholder === "false") {
            let tempButton = document.createElement("a");
            tempButton.id = "";
            if (loadedDom < 1) {
              loadedDom = 1;
              tempButton.classList.add("btn-soldier", "btn-active");
            } else {
              tempButton.classList.add("btn-soldier");
            }
            tempButton.innerText =
              soldierData[i].lastName + " " + soldierData[i].firstName;
            tempButton.setAttribute("id", i);
            tempButton.addEventListener("click", function () {
              let tempID = this.id;
              selectSoldier(tempID, false);
            });
            soldierNavbar.appendChild(tempButton);
            soldierButtons.push(tempButton);
          }
        }
      }
    });
    switch (countryTag) {
      case "GBR":
        countryName.innerHTML =
          '<span class="flag-icon flag-icon-gb flag-soldier-name"></span>Jungtinė Karalystė';
        break;
      case "USA":
        countryName.innerHTML =
          '<span class="flag-icon flag-icon-us flag-soldier-name"></span>Jungtinės Amerikos Valstijos';
        break;
      case "CAN":
        countryName.innerHTML =
          '<span class="flag-icon flag-icon-ca flag-soldier-name"></span>Kanada';
        break;
      case "VEN":
        countryName.innerHTML =
          '<span class="flag-icon flag-icon-ve flag-soldier-name"></span>Venesuela';
        break;
      case "FRA":
        countryName.innerHTML =
          '<span class="flag-icon flag-icon-fr flag-soldier-name"></span>Prancūzija';
        break;
    }
    moveToTop();
    document.getElementById("mainMenu").style.display = "none";
    map.classList.add("blured");
    document.getElementById("btnAboutProject").style.display = "none";
    document.getElementById("btnCountryMenu").style.display = "none";
    credits.style.display = "none";
    document.getElementById("btnGoBack").style.display = "block";
    document.getElementById("soldierPanel").style.display = "block";
    document.getElementById("btnSoldierMenu").style.display = "block";
    // SELECT BY ID!!!!!!!!!!!!!
    selectSoldier(36, false);
    //
    document.querySelectorAll(".btn-soldier").forEach(function (element) {
      return element.classList.remove("btn-active");
    });
    document.getElementById(36).classList.add("btn-active");
  }

  history.pushState({}, "", window.location.pathname);
}

getWindowLocationPath();

function preload() {
  imgPlaceholder.src = "gfx/placeholder.png";
}

preload();

/* DOM manipulation */

function addClassToDom(domID, className) {
  let dom = document.querySelector("#" + domID);
  dom.classList.add(className);
}

function removeClassFromDom(domID, className) {
  let dom = document.querySelector("#" + domID);
  dom.classList.remove(className);
}
